import { ASSETS_TYPES } from '@modules/consolidator/constants/Assets'

export const corretoras = {
  xp: 'XP',
  bb: 'Banco do Brasil',
  itau: 'Itaú',
  santander: 'Santander',
  bradesco: 'Bradesco',
  btg: 'BTG Pactual',
  safra: 'Safra',
  genial: 'Genial',
}

export const corretorasReverse = {
  XP: 'xp',
  'Banco do Brasil': 'bb',
  Itaú: 'itau',
  Santander: 'santander',
  Bradesco: 'bradesco',
  'BTG Pactual': 'btg',
  Safra: 'safra',
  Genial: 'genial',
}

export const ICONES_EVENTS = {
  Inicial: {
    name: 'minus',
    color: 'grey darken-1',
  },
  Resgate: {
    name: 'chevron-down',
    color: 'error',
  },
  'Resgate total': {
    name: 'chevron-down',
    color: 'error',
  },
  'Resgate Total': {
    name: 'chevron-down',
    color: 'error',
  },
  Aplicação: {
    name: 'chevron-up',
    color: 'light-green darken-3',
  },
  Proventos: {
    name: 'currency-usd', // plus
    color: 'info',
  },
  Desdobramento: {
    name: 'percent',
    color: 'yellow darken-3',
  },
  Agrupamento: {
    name: 'percent',
    color: 'yellow darken-3',
  },
  Cupom: {
    name: 'label-percent-outline',
    color: 'green darken-3',
  },
  Amortização: {
    name: 'hand-coin-outline',
    color: 'green darken-3',
  },
  Vencimento: {
    name: 'calendar-outline',
    color: 'secondary',
  },
  'Bonificação (%)': {
    name: 'percent-circle-outline',
    color: 'amber lighten-1',
  },
  'Bonificação (fracionário)': {
    name: 'percent-circle-outline',
    color: 'amber lighten-1',
  },
  default: {
    name: 'calendar-blank-outline',
    color: 'secondary',
  },
}

/**
 * Controlar os modais registrados
 */
export const MODAL = {
  /**
   * Módulo Tarefas — modal de permissões de pasta/lista (permissoes-pasta-lista).
   * Emitido pela task-sidebar (item "Permissões" do menu de pasta/lista), ouvido
   * pelo permissions-modal. Payload: { targetType, targetId, targetName } —
   * targetType ∈ {'folder','sprint'}.
   */
  TASK_PERMISSIONS: 'modal_task_permissions',
  /**
   * Módulo Tarefas — modal "Espelhar em" (espelhar tarefa em outra lista/sprint).
   * Disparado pelo menu da task-card ou pelo painel de espelhos. Payload:
   * { taskId }.
   */
  TASK_ESPELHAR_EM: 'modal_task_espelhar_em',
  /**
   * Disparado pelo EspelharEmModal após criar espelho(s) com sucesso.
   * Payload: { taskId }. Usado pelo MirrorsSidePanel para recarregar.
   */
  TASK_ESPELHAR_SUCCESS: 'task_espelhar_success',
  /**
   * Módulo Tarefas — painel lateral com os espelhamentos da tarefa.
   * Disparado pelo clique no badge de espelho. Payload: { taskId }.
   * Canal SEPARADO de TASK_ESPELHAR_EM de propósito: o menu "···" abre o modal
   * de escolha de destinos, o badge abre este painel. Assinar os dois no mesmo
   * canal fazia o clique em "Espelhar" abrir as duas telas ao mesmo tempo.
   */
  TASK_MIRRORS_PANEL: 'task_mirrors_panel',
  /**
   * Módulo Fee Fixo — modal "Salvar análise".
   * Disparado pela calculadora ao concluir uma simulação. Payload:
   * { codigo_cliente, nome_cliente, inputs, resultados, score,
   *   status_elegibilidade, cenario_captacao }. Ao salvar, emite
   * FEE_FIXO_RELOAD_ANALISES.
   */
  FEE_FIXO_SALVAR_ANALISE: 'modal_fee_fixo_salvar_analise',
  /**
   * Módulo Fee Fixo — modal "O que entra no relatório" (12/08/2026).
   * O consultor escolhe as seções do PDF antes de gerá-lo. Payload:
   * `{ aoConfirmar(secoes) }` — o modal NÃO gera nada, devolve a escolha por
   * callback e quem dispara continua sendo a view (é lá que vivem o snack dos
   * 2 minutos e o `finally` do loading).
   */
  FEE_FIXO_SECOES_RELATORIO: 'modal_fee_fixo_secoes_relatorio',
  /**
   * Módulo Fee Fixo — modal "Gerar apresentação" (spec-001 do
   * project-generate-ppt-with-ai). O consultor escolhe formato (PDF ou PPTX),
   * motor de geração, seções e um texto livre sobre o cliente. Payload:
   * `{ analiseId, motoresDisponiveis }` — `motoresDisponiveis` é a lista de
   * `{ valor, rotulo, descricao, disponivel, motivo }` que o backend informa.
   * O modal NÃO gera nada: emite `gerar` com a escolha, e quem dispara e
   * acompanha o progresso é a view.
   */
  FEE_FIXO_GERAR_APRESENTACAO: 'modal_fee_fixo_gerar_apresentacao',
  /**
   * Módulo Fee Fixo — o relatório do cenário terminou de baixar (13/08/2026).
   *
   * Sinal de que o PDF do cenário FICOU PRONTO e baixou. Sem payload; só o
   * caminho de sucesso emite.
   *
   * Existe porque gerar o relatório é a única ação do módulo que termina longe
   * do clique: passa por duas Lambdas e pode levar até 2 minutos. Quem precisa
   * saber que acabou é o tour guiado, que sem isto ficaria pedindo "clique em
   * Gerar relatório" com o documento já baixado — o mesmo papel que
   * FEE_FIXO_RELOAD_CLIENTES cumpre para a importação.
   */
  FEE_FIXO_RELATORIO_GERADO: 'modal_fee_fixo_relatorio_gerado',
  /**
   * Módulo Fee Fixo — drawer de avaliação de um ensaio (spec-024 T4/T5).
   * Recebe { id_sessao }; quem emite é a tela do ensaio, no clique da linha
   * do histórico ou ao encerrar uma sessão e gerar a nota.
   */
  FEE_FIXO_AVALIACAO_ENSAIO: 'modal_fee_fixo_avaliacao_ensaio',
  /**
   * Módulo Fee Fixo — modal "Importar clientes" (planilha).
   * Sem payload. Fluxo de 2 passos: valida a planilha (preview com contadores e
   * erros por linha) e só grava após confirmação. Ao concluir, emite
   * FEE_FIXO_RELOAD_CLIENTES.
   */
  FEE_FIXO_IMPORTAR_CLIENTES: 'modal_fee_fixo_importar_clientes',
  /**
   * Sinal do upload de clientes para o tour guiado. Sem payload: escolher um
   * arquivo conclui o passo da dropzone e libera o passo de validação.
   */
  FEE_FIXO_ARQUIVO_CLIENTES_SELECIONADO:
    'modal_fee_fixo_arquivo_clientes_selecionado',
  /**
   * Sinal para a view de clientes recarregar a listagem após uma importação.
   * Sem payload.
   */
  FEE_FIXO_RELOAD_CLIENTES: 'modal_fee_fixo_reload_clientes',
  /**
   * Módulo Fee Fixo — modal "Importar carteira" (diversificador XP/BTG).
   * Sem payload. Mesmos 2 passos da importação de clientes, em rota própria:
   * o preview traz total de ativos, PL somado e quantos ficaram sem classe, e
   * só a confirmação zera o ativo fictício e grava. Ao concluir, emite
   * FEE_FIXO_RELOAD_CARTEIRA.
   */
  FEE_FIXO_IMPORTAR_ATIVOS: 'modal_fee_fixo_importar_ativos',
  /**
   * Sinal para a simulação reler a alocação do cliente após a importação da
   * carteira. Sem payload. Separado de FEE_FIXO_RELOAD_CLIENTES porque o que
   * muda aqui é a composição da carteira, não a listagem — recarregar a lista
   * inteira do escritório para atualizar um rótulo seria caro e inútil.
   */
  FEE_FIXO_RELOAD_CARTEIRA: 'modal_fee_fixo_reload_carteira',
  /**
   * Módulo Fee Fixo — anexo do extrato de UM cliente na conversa do guia
   * (spec-004). Sem payload: quem abre é o clipe do compositor, e o cliente é
   * escolhido dentro do modal.
   *
   * O RESULTADO não volta por outro canal do bus: o modal é montado pela
   * própria view do guia e emite `enviado` para ela, que insere o card no
   * thread. Um segundo canal aqui só faria a resposta poder chegar a uma tela
   * que não pediu nada.
   */
  FEE_FIXO_CARTEIRA_CHAT_ANEXO: 'modal_fee_fixo_carteira_chat_anexo',
  /**
   * Módulo Fee Fixo — escolher o cliente cuja conversa vai abrir na aba Guia
   * (spec-005, [T008] — US-5). Sem payload: quem abre é o "+" do grupo
   * Clientes da lateral, e o cliente é escolhido dentro do modal. O resultado
   * volta por evento LOCAL (`escolhido`), não por um segundo canal do bus —
   * quem abre/retoma a conversa é a view, dona do thread.
   */
  FEE_FIXO_CONVERSA_CLIENTE: 'modal_fee_fixo_conversa_cliente',
  /**
   * Módulo Fee Fixo — modal "Criar tarefa" de acompanhamento da migração.
   * Payload: { codigo_cliente, nome_cliente }. Ao salvar, cria a tarefa via
   * project-management e emite FEE_FIXO_RELOAD_KANBAN.
   */
  FEE_FIXO_CRIAR_TAREFA: 'modal_fee_fixo_criar_tarefa',
  /**
   * Sinal para a view de histórico/calculadora recarregar as análises de um
   * cliente após um salvamento. Payload opcional: { codigo_cliente }.
   */
  FEE_FIXO_RELOAD_ANALISES: 'modal_fee_fixo_reload_analises',
  /**
   * Módulo Fee Fixo — modal "Histórico de Análises" do cliente.
   * Payload: { codigo_cliente, nome_cliente }. Permite carregar uma análise
   * anterior para revisar os parâmetros e resultados.
   */
  FEE_FIXO_HISTORICO_ANALISES: 'modal_fee_fixo_historico_analises',
  /**
   * Módulo Fee Fixo — sinal para carregar uma análise salva na calculadora.
   * Emitido pelo modal de histórico ao clicar em "Carregar".
   * Payload: objeto da análise com { inputs, resultados, ... }.
   */
  FEE_FIXO_CARREGAR_ANALISE: 'modal_fee_fixo_carregar_analise',
  /**
   * Sinal para a view de Kanban recarregar as tarefas após criar/mover.
   * Sem payload.
   */
  FEE_FIXO_RELOAD_KANBAN: 'modal_fee_fixo_reload_kanban',
  /**
   * Módulo Fee Fixo — modal "Criar tarefas em lote" para múltiplos clientes.
   * Payload: { clientes: [{ codigo_cliente, nome_cliente, id_cliente_app }] }.
   * Ao salvar, cria as tarefas via batch endpoint e emite FEE_FIXO_BATCH_CREATED.
   */
  FEE_FIXO_CRIAR_TAREFAS_BATCH: 'modal_fee_fixo_criar_tarefas_batch',
  /**
   * Sinal emitido após criação de tarefas em lote.
   * Usado pela view dashboard para limpar a seleção. Sem payload.
   */
  FEE_FIXO_BATCH_CREATED: 'modal_fee_fixo_batch_created',
  /**
   * Módulo Fee Fixo — modal "Adicionar clientes ao Pipeline" (em lote).
   * Payload: { clientes: [{ codigo_cliente, nome_cliente, id_cliente_app, valor_estimado }] }.
   * Ao salvar, adiciona os leads via /pipeline/leads e emite FEE_FIXO_RELOAD_PIPELINE.
   */
  FEE_FIXO_ADICIONAR_PIPELINE: 'modal_fee_fixo_adicionar_pipeline',
  /**
   * Sinal para a view de Pipeline recarregar o funil/leads após adicionar ou mover.
   * Sem payload.
   */
  FEE_FIXO_RELOAD_PIPELINE: 'modal_fee_fixo_reload_pipeline',
  /**
   * Modal de simulação em batch. Recebe lista de clientes e parâmetros padrão.
   * Payload: { clientes: [...] }. Ao salvar com sucesso, emite
   * FEE_FIXO_SIMULACAO_BATCH_APLICADA.
   */
  FEE_FIXO_SIMULACAO_BATCH: 'modal_fee_fixo_simulacao_batch',
  /**
   * Sinal emitido após adicionar clientes ao pipeline em lote (pelo menos 1
   * sucesso). Usado pela view "Clientes da Carteira" pra limpar a seleção
   * (v-model da tabela) — sem isso, os clientes ficavam marcados na barra de
   * ações em lote mesmo após o batch já ter sido processado. Sem payload.
   */
  FEE_FIXO_SIMULACAO_BATCH_APLICADA: 'modal_fee_fixo_simulacao_batch_aplicada',
  /**
   * Abre o painel do Especialista Fee-Based (agente de IA das telas de Fee
   * Fixo). Sem payload abre vazio; com { pergunta: '...' } já envia a pergunta
   * — é assim que uma tela oferece um atalho ("por que este cliente não
   * cruza?") sem duplicar a interface do chat.
   */
  FEE_FIXO_IA_ESPECIALISTA: 'modal_fee_fixo_ia_especialista',
  /**
   * Modal de geração de chave de API do módulo IA Operacional.
   * Disparado em IA > Chaves de API. Sem payload.
   */
  IA_API_KEY_CREATE: 'modal_ia_api_key_create',
  /**
   * Modal do guia "Como configurar o Claude Code" do módulo IA Operacional.
   * Disparado em IA > Chaves de API. Sem payload. Carrega o guia por sessão
   * (não exige chave crua), permitindo rever a configuração a qualquer momento.
   */
  IA_CLAUDE_CODE_GUIDE: 'modal_ia_claude_code_guide',
  IA_SUGGESTION_EDIT: 'modal_ia_suggestion_edit',
  CONSOLIDADOR_EDIT_ASSET_SUGGESTION:
    'modal_consolidador_edit_asset_suggestion',
  IA_SUGGESTION_DECLINE: 'modal_ia_suggestion_decline',
  /**
   * Modal de criar/editar skill da IA (spec-007-aprovacao-de-skills-por-risco
   * [T030], `contracts/ui-components.md` §9). Payload: { skill: Object|null,
   * publicacao?: string } — `skill` null = criação; `publicacao` presente =
   * edição de uma publicação vinda da timeline "O que a IA aprendeu" (chama
   * `apiAprendizado.editar` em vez de `apiSkillsGestao.editar`).
   */
  IA_SKILL_EDITAR: 'modal_ia_skill_editar',
  /**
   * Modal de criação de pasta de conversas (IA Operacional). Sem payload —
   * apenas coleta o nome. A cor é atribuída pelo backend (round-robin).
   */
  IA_FOLDER_CREATE: 'modal_ia_folder_create',
  /**
   * Modal de renomear pasta de conversas (IA Operacional).
   * Payload: { folder: { id, name } }.
   */
  IA_FOLDER_RENAME: 'modal_ia_folder_rename',
  /**
   * Aprovação de skills por risco (spec-007-aprovacao-de-skills-por-risco,
   * [T021], `contracts/ui-components.md` §4-6/9). Modal de "Desfazer" uma
   * publicação (skill ou memória). Payload: { item }.
   */
  IA_PUBLICACAO_REVERTER: 'modal_ia_publicacao_reverter',
  /**
   * Modal de recusa de um aprendizado aguardando decisão humana.
   * Payload: { item }.
   */
  IA_APROVACAO_RECUSAR: 'modal_ia_aprovacao_recusar',
  /**
   * Modal de "Publicar com edição" / "Editar publicação" — two-step com
   * pré-visualização antes de confirmar. Payload: { item, modo: 'publicar' | 'editar' }.
   */
  IA_APROVACAO_EDITAR: 'modal_ia_aprovacao_editar',
  /**
   * Modal de motivo obrigatório para `lifecycle(skill, para)` — substitui o
   * `window.prompt` provisório de `view-skills-ia.vue` (compromisso de UX
   * documentado, `contracts/ui-components.md` §7). Payload:
   * { skill: Object, para: 'archived' | 'published' }.
   */
  IA_SKILL_MOTIVO: 'modal_ia_skill_motivo',
  /**
   * Modal two-step de promoção de decisão a Conhecimento oficial
   * (spec-013-knowledge-por-escritorio-e-promocao-de-decisao, [T007],
   * `contracts/ui-components.md` §4). Passo 1 formulário → Pré-visualizar →
   * passo 2 preview/diff → Confirmar. Payload:
   * { item: Object|null, tipos: Array, payloadInicial?: Object, name?: String,
   * description?: String, sugestao?: Object } — `item` null = Registrar;
   * presente = Atualizar (`base_version = item.version`); `payloadInicial`
   * pré-preenche o formulário com o conteúdo de uma versão antiga
   * ("Reverter para vN" — nova promoção humana, nunca desfazer);
   * `sugestao` pré-preenche a partir de uma pendência de promoção (US-7).
   */
  IA_CONHECIMENTO_PROMOVER: 'modal_ia_conhecimento_promover',
  /**
   * Modal de motivo obrigatório (≥ 5 chars) para "Encerrar vigência" de um
   * conhecimento oficial (spec-013 [T023], `contracts/ui-components.md` §1 —
   * `encerrar`). Payload: `{ item: Object }`. Não existe `$showModal` com
   * `input-by-type` reativo neste app (`the-feedback.vue` só renderiza
   * `text`/`html` estáticos — `v-html` não compila `v-model`); o molde real
   * para "motivo obrigatório antes de uma ação" é este, o mesmo de
   * `IA_SKILL_MOTIVO` (spec-007). Emite `@confirm({ item, motivo })`; quem
   * chama `apiKnowledge.promover({..., encerrar: true, confirmar: true})` e
   * recarrega é a view dona (`view-conhecimento.vue`).
   */
  IA_CONHECIMENTO_ENCERRAR: 'modal_ia_conhecimento_encerrar',
  /**
   * Modal de motivo obrigatório (≥ 5 chars) para "Descartar" uma pendência
   * de promoção a Knowledge oficial (spec-013 [T031], `contracts/
   * ui-components.md` §1 — `descartarPendencia`, UC-8). Payload:
   * `{ pendencia: Object }`. Mesmo desvio deliberado de `IA_CONHECIMENTO_
   * ENCERRAR` (não existe `$showModal` com `input-by-type` reativo neste
   * app) — molde idêntico, campo próprio para não acoplar o descarte de
   * pendência ao encerramento de vigência (payloads diferentes: `item`
   * vigente vs. `pendencia` de `_aprovacoes`). Emite
   * `@confirm({ pendencia, motivo })`; quem chama
   * `apiKnowledge.descartarPendencia({ idAprovacao: pendencia.id_aprovacao,
   * motivo })` e recarrega só as pendências é `view-conhecimento.vue`.
   */
  IA_CONHECIMENTO_PENDENCIA_DESCARTAR: 'modal_ia_conhecimento_pendencia_descartar',
  /**
   * Modal de detalhe de transcrição (CRM > Transcrições).
   * Disparado ao clicar numa linha do histórico ou em "Acompanhar" de um card
   * ao vivo. Payload: { id }. Faz fetch via apiCrmTranscricoes.detalhar e, se a
   * reunião está in_progress, faz polling do transcript/sentimento.
   */
  TRANSCRIPT_DETAIL: 'modal_transcript_detail',
  /**
   * Modal de edição rápida do nome (title) e descrição de uma transcrição
   * (CRM > Transcrições). Disparado pelo botão "Editar" do histórico.
   * Payload: { item }. Ao salvar, emite RELOAD.TRANSCRIPT.
   */
  TRANSCRIPT_EDIT: 'modal_transcript_edit',
  /**
   * Modal de edição do cliente vinculado a uma transcrição (CRM > Transcrições).
   * Disparado pelo lápis "Editar cliente" no cabeçalho do detalhe.
   * Payload: { id, id_cliente }. Ao salvar, emite RELOAD.TRANSCRIPT.
   */
  TRANSCRIPT_CLIENT: 'modal_transcript_client',
  /**
   * Modal de edição do projeto vinculado a uma transcrição (CRM > Transcrições).
   * Disparado pelo lápis "Editar projeto" no cabeçalho do detalhe.
   * Payload: { id, id_project }. Ao salvar, emite RELOAD.TRANSCRIPT.
   */
  TRANSCRIPT_PROJECT: 'modal_transcript_project',
  /**
   * Modal de edição dos participantes de uma transcrição (CRM > Transcrições).
   * Disparado pelo lápis/"Adicionar participante" da aba Participantes.
   * Payload: { id, participants }. Ao salvar, emite RELOAD.TRANSCRIPT.
   */
  TRANSCRIPT_PARTICIPANTS: 'modal_transcript_participants',
  /**
   * Painel de curadoria das sugestões de IA de UM ESCOPO (reunião OU cliente) —
   * modal genérico e domain-agnostic, reusado por CRM > Transcrições > Histórico
   * (ícone de alerta da linha/"Revisar" do popover) e por Relacionamento >
   * Clientes/Tarefas + Kanban de Leads (badge de alerta da linha/card). Payload:
   * { scope: { tipo: 'transcript' | 'cliente', id }, subtitulo } — `subtitulo` é
   * uma string pré-formatada que o chamador monta (o modal não conhece nomes de
   * campo de nenhum domínio). Consolida os antigos TRANSCRIPT_SUGGESTIONS
   * (spec-005) e CRM_CLIENT_SUGGESTIONS (spec-007) — extensível a futuros
   * módulos (Consolidador, Compliance, ...) sem duplicar o modal.
   */
  IA_SUGGESTIONS: 'modal_ia_suggestions',
  /**
   * Sinal de que a fila de sugestões de um escopo mudou (aceite/recusa no
   * painel). Payload: { scope, pendentes } — cada view decide o que fazer com a
   * contagem fresca (ex.: histórico de transcrições patcha a linha local;
   * Relacionamento/Leads propagam via global-modals quando scope.tipo é
   * 'cliente'). Substitui TRANSCRIPT_SUGGESTIONS_CHANGED.
   */
  IA_SUGGESTIONS_CHANGED: 'ia_suggestions_changed',
  /**
   * Modal de criação/edição de Projeto (CRM > Transcrições > Projetos).
   * Gestor-only. Payload opcional: { project } para edição (sem payload = criar).
   * Ao salvar, emite TRANSCRIPT_PROJECTS_RELOAD.
   */
  TRANSCRIPT_PROJECT_EDIT: 'modal_transcript_project_edit',
  /**
   * Sinal para a aba Projetos recarregar a lista após criar/editar/remover um
   * projeto. Sem payload.
   */
  TRANSCRIPT_PROJECTS_RELOAD: 'modal_transcript_projects_reload',
  /**
   * Modal de gestão dos critérios de avaliação de um Projeto (CRM > Transcrições
   * > Projetos). Gestor-only. Payload: { project } (id, name, is_global). Projeto
   * global é somente leitura.
   */
  TRANSCRIPT_CRITERIAS: 'modal_transcript_criterias',
  /**
   * Modal de edição/criação de classe ANBIMA do escritório.
   * Disparado em Configurações > Classes ANBIMA. Payload opcional: { item }.
   */
  ANBIMA_CLASS_EDIT: 'modal_anbima_class_edit',
  /**
   * Modal de edição/criação do de-para classe interna → classe ANBIMA.
   * Payload opcional: { item }.
   */
  ANBIMA_CLASS_MAPPING_EDIT: 'modal_anbima_class_mapping_edit',
  /**
   * Modal do rules engine v2 — criação/edição de regra de mapeamento ANBIMA com conditions JSONB.
   * Payload opcional: { rule } — se presente abre em modo edição.
   */
  ANBIMA_RULE_EDIT: 'ANBIMA_RULE_EDIT',
  /**
   * Modal de máximos por classe ANBIMA por perfil estratégico.
   * Payload obrigatório: { id_composicao_estrategica, perfil_nome, composicao }.
   */
  ANBIMA_MAX_BY_PROFILE: 'modal_anbima_max_by_profile',
  /**
   * Nova versão disponível — disparado quando ocorre ChunkLoadError após deploy
   * OU quando o heartbeat proativo (version-check.js) detecta um deploy.
   * Modal pede ao usuário para clicar em "Atualizar agora" para recarregar a SPA.
   * Payload opcional: { autoReload: boolean } — true mantém auto-reload em 2s
   * (caso reativo de chunk error), false só notifica e deixa o usuário decidir
   * (caso proativo via heartbeat/visibility).
   */
  NEW_VERSION_AVAILABLE: 'new_version_available',
  /**
   * Disparado quando o usuário fecha o modal de nova versão sem atualizar.
   * Consumido pelo version-check.js para bloquear próximos triggers proativos
   * na mesma sessão (chunk error reativo continua disparando).
   */
  NEW_VERSION_DISMISSED: 'new_version_dismissed',
  /**
   * modal_consolidador_register_asset
   */
  CONSOLIDADOR_REGISTER_ASSET: 'modal_consolidador_register_asset',
  /**
   * back_office_confirm_with_notes
   */
  BACK_OFFICE_CONFIRM_WITH_NOTES: 'back_office_confirm_with_notes',
  /**
   * back_office_suggestion_detail
   */
  BACK_OFFICE_SUGGESTION_DETAIL: 'back_office_suggestion_detail',
  /**
   * modal_adicionar_receita_ou_despesa
   */
  MODAL_ADICIONAR_RECEITA_OU_DESPESA: 'modal_adicionar_receita_ou_despesa',
  /**
   * modal_analise_monte_carlo
   */
  MODAL_ANALISE_MONTE_CARLO: 'modal_analise_monte_carlo',
  /*
   * portfolio_review_edit_notes
   */
  PORTFOLIO_REVIEW_EDIT_NOTES: 'portfolio_review_edit_notes',
  /**
   * modal_add_account_open_finance
   */
  MODAL_ADD_ACCOUNT_OPEN_FINANCE: 'modal_add_account_open_finance',
  /**
   * modal_add_subcategories_financial_planning
   */
  MODAL_ADD_SUBCATEGORIES_FINANCIAL_PLANNING:
    'modal_add_subcategories_financial_planning',
  /**
   * modal_add_categories_financial_planning
   */
  MODAL_ADD_CATEGORIES_FINANCIAL_PLANNING:
    'modal_add_categories_financial_planning',
  /**
   * back_office_file_viewer (visualizador genérico de arquivos em base64)
   */
  BACK_OFFICE_FILE_VIEWER: 'back_office_file_viewer',
  /**
   * back_office_batch_upload
   */
  BACK_OFFICE_BATCH_UPLOAD: 'back_office_batch_upload',
  /**
   * back_office_status_comparison
   */
  BACK_OFFICE_ASSETS_COMPARISON: 'back_office_status_comparison',
  /**
   * back_office_validation_detail
   */
  BACK_OFFICE_VALIDATION_DETAIL: 'back_office_validation_detail',
  /**
   * back_office_movements_validation
   */
  BACK_OFFICE_MOVEMENTS_VALIDATION: 'back_office_movements_validation',
  /**
   * modal_clients_relatorios_anbima
   */
  CLIENTS_RELATORIOS_ANBIMA: 'modal_clients_relatorios_anbima',
  /**
   * modal_clients_carteira_administrada
   */
  CLIENTS_CARTEIRA_ADMINISTRADA: 'modal_clients_carteira_administrada',
  /**
   * modal_consolidador_batch_events
   */
  CONSOLIDADOR_BATCH_EVENTS: 'modal_consolidador_batch_events',
  /**
   * modal_open_consolidator
   */
  MODAL_SELECT_REPORT_TYPE_CONSOLIDATOR:
    'modal_select_report_type_consolidator',
  /**
   * modal_consolidador_wallet_status_toggle
   */
  CONSOLIDADOR_WALLETSTATUSTOGGLE: 'modal_consolidador_wallet_status_toggle',
  /**
   * modal_consolidador_wallet_custom_date
   */
  CONSOLIDADOR_WALLET_CUSTOM_DATE: 'modal_consolidador_wallet_custom_date',
  /**
   * COMMENTS_VERSIONS
   */
  MODAL_COMMENTS_VERSIONS: 'modal_comments_versions',
  /**
   * modal_open_search_text
   */
  OPEN_SEARCH_TEXT: 'modal_open_search_text',
  /**
   * modal_compliance_client
   */
  COMPLIANCE_CLIENT: 'modal_compliance_client',
  /**
   * modal_open_details_repository
   */
  OPEN_DETAILS_REPOSITORY: 'modal_open_details_repository',
  /**
   * modal_warning_departments_additional_information
   */
  WARNING_DEPARTMENTS_ADDITIONAL_INFORMATION:
    'modal_warning_departments_additional_information',
  /**
   * modal_alert_departments_inactive
   */
  ALERT_DEPARTMENTS_INACTIVE: 'modal_alert_departments_inactive',
  /**
   * modal_comissoes_open_import_base_reference
   */
  COMISSOES_OPEN_IMPORT_BASE_REFERENCE:
    'modal_comissoes_open_import_base_reference',
  /**
   * modal_consolidador_add_investment_account
   */
  CONSOLIDADOR_ADD_INVESTMENT_ACCOUNT:
    'modal_consolidador_add_investment_account',
  /**
   * modal_consolidador_add_portfolio
   */
  CONSOLIDADOR_ADD_PORTFOLIO: 'modal_consolidador_add_portfolio',
  /**
   * modal_consolidador_add_rf_category
   */
  CONSOLIDADOR_ADD_RF_CATEGORY: 'modal_consolidador_add_rf_category',
  CONSOLIDADOR_RELINK_BASE_ASSET: 'modal_consolidador_relink_base_asset',
  /**
   * modal_integration_logs
   */
  MODAL_INTEGRATION_LOGS: 'modal_integration_logs',
  /**
   * modal_donwload_dre
   */
  FINANCE_DOWNLOAD_DRE: 'finance_modal_download_dre',
  /**
   * open_details_comission_category_finance
   */
  OPEN_DETAILS_COMISSION_CATEGORY_FINANCE:
    'open_details_comission_category_finance',
  /**
   * global_pdf_preview
   */
  GLOBAL_PDF_PREVIEW: 'global_pdf_preview',
  /**
   * Busca global (command palette) da navbar — abre via lupa ou Ctrl+K
   */
  GLOBAL_SEARCH: 'modal_global_search',
  /**
   * Palette da IA — abre por Ctrl/Cmd+K dentro da `/ia` e pelo comando
   * `/buscar` do composer. Substitui a busca global naquela rota: lá o Ctrl+K
   * precisa mostrar conversas, agentes e modelos, não as páginas da plataforma.
   */
  IA_PALETTE: 'modal_ia_palette',
  /**
   * ADD_SIGNATARIOS_CONTRATOS
   */
  ADD_SIGNATARIOS_CONTRATOS: 'add_signatarios_contratos',
  /**
   * import_batch_juridico
   */
  IMPORT_BATCH_JURIDICO: 'import_batch_juridico',
  /**
   * modal_add_coment_corretora
   */
  ADD_COMENT_CORRETORA: 'add_coment_corretora',
  /**
   * modal_commercial_add_permission
   */
  COMMERCIAL_ADD_PERMISSION: 'modal_commercial_add_permission',
  /**
   * modal_commercial_assign_conversation_responsibility
   */
  COMMERCIAL_ASSIGN_CONVERSATION_RESPONSIBILITY:
    'modal_commercial_assign_conversation_responsibility',
  /**
   * form_send_message
   */
  FORM_SEND_MESSAGE: 'form_send_message',
  /**
   * commercial_historical_conversation
   */
  COMMERCIAL_HISTORICAL_CONVERSATION: 'modal_historical_conversation',
  /**
   * import_success_warning
   */
  IMPORT_SUCCESS_WARNING: 'import_success_warning',
  /**
   * open_valuation_single
   */
  OPEN_VALUATION_SINGLE: 'open_valuation_single',
  /**
   * open_valuation_single
   */
  CLIENTS_EXPORT_TAXES: 'clients_export_taxes',
  /**
   * Modal de exportação dos ativos de todos os clientes visíveis numa data
   * (Clientes > "Exportar ativos"). Sem payload — usa data selecionada no modal.
   */
  CLIENTS_EXPORT_ASSETS: 'clients_export_assets',
  /**
   * Modal de upload em lote de cashback (Clientes > "Subir cashback").
   * Sem payload — recebe arquivo .xlsx/.csv (login | valor | data).
   */
  CLIENTS_CASHBACK_UPLOAD: 'clients_cashback_upload',
  /**
   * modal_select_client
   */
  SELECIONAR_CLIENTE: 'modal_select_client',
  /**
   * modal_cadastrar_servicos
   */
  CADASTRAR_SERVICOS: 'modal_cadastrar_servicos',
  /**
   * financial_planning_edit_budgets
   */
  FINANCIAL_PLANNING_EDIT_BUDGETS: 'financial_planning_edit_budgets',
  /**
   * financial_planning_category_templates
   */
  FINANCIAL_PLANNING_CATEGORY_TEMPLATES:
    'financial_planning_category_templates',
  /**
   * MODAL.FINANCIAL_PLANNING_CATEGORY_DRAWER
   */
  FINANCIAL_PLANNING_CATEGORY_DRAWER:
    'MODAL.FINANCIAL_PLANNING_CATEGORY_DRAWER',
  /**
   * MODAL.FINANCIAL_PLANNING_ADD_TRANSACTION
   */
  FINANCIAL_PLANNING_ADD_TRANSACTION:
    'MODAL.FINANCIAL_PLANNING_ADD_TRANSACTION',
  /**
   * MODAL.FINANCIAL_PLANNING_GOAL_MODAL
   */
  FINANCIAL_PLANNING_GOAL_MODAL: 'MODAL.FINANCIAL_PLANNING_GOAL_MODAL',
  /**
   * MODAL.FINANCIAL_PLANNING_PATRIMONY_MODAL
   */
  FINANCIAL_PLANNING_PATRIMONY_MODAL:
    'MODAL.FINANCIAL_PLANNING_PATRIMONY_MODAL',
  /**
   * MODAL.FINANCIAL_PLANNING_RULES
   */
  FINANCIAL_PLANNING_RULES: 'MODAL.FINANCIAL_PLANNING_RULES',
  /**
   * MODAL.FP_TRANSACTION_CATEGORY
   *
   * Folha de recategorização do CLIENTE final (a única escrita que ele pode
   * fazer). Canal único: quem precisa reabrir com outro estado emite de novo
   * com payload diferente — sem `_UPDATE`/`_CLOSE`.
   */
  FP_TRANSACTION_CATEGORY: 'MODAL.FP_TRANSACTION_CATEGORY',
  /**
   * MODAL.FP_PERIOD
   *
   * Folha de seleção de período do cliente final. Mesmo contrato de canal
   * único do modal acima.
   */
  FP_PERIOD: 'MODAL.FP_PERIOD',
  /**
   * financial_planning_goal_link
   */
  FINANCIAL_PLANNING_GOAL_LINK: 'financial_planning_goal_link',
  /**
   * financial_planning_goal_allocations
   */
  FINANCIAL_PLANNING_GOAL_ALLOCATIONS: 'financial_planning_goal_allocations',
  /**
   * financial_planning_comparison
   */
  FINANCIAL_PLANNING_COMPARISON: 'financial_planning_comparison',
  /**
   * modal_cadastrar_clientes
   */
  CADASTRAR_CLIENTES: 'modal_cadastrar_clientes',
  /**
   * modal_compliance_cadastrar_clientes
   */
  COMPLIANCE_CADASTRAR_CLIENTES: 'modal_compliance_cadastrar_clientes',
  /**
   * modal_cadastrar_ativo
   */
  CADASTRAR_ATIVO: 'modal_cadastrar_ativo',
  /**
   * modal_aporte_resgate
   */
  CADASTRAR_APORTE: 'modal_aporte_resgate',
  /**
   * modal_cadastrar_conta
   */
  CADASTRAR_CONTA: 'modal_cadastrar_conta',
  /**
   * modal_client_ips
   */
  IPS: 'modal_client_ips',
  /**
   * modal_show_videos
   */
  SHOW_VIDEOS: 'modal_show_videos',
  /**
   * modal_responder_ips_cliente
   */
  ANSWER_CLIENTE: 'modal_responder_ips_cliente',
  /**
   * modal_contato_whitelabel
   */
  CONTACT_WHITELABEL: 'modal_contato_whitelabel',
  /**
   * modal_aceitar_ativos
   */
  ACEITAR_ATIVOS: 'modal_aceitar_ativos',
  /**
   * modal_carteira_data
   */
  DATE_WALLET: 'modal_carteira_data',
  /**
   * Modal para preencher os filtros de cliente
   *
   * modal_filter_client
   */
  FILTRO_CLIENTE: 'modal_filter_client',
  /**
   * Modal para preencher os filtros de serviços
   *
   * modal_filter_service
   */
  FILTRO_SERVICOS: 'modal_filter_service',
  /**
   * Modal para inserir o token do banco
   *
   * modal_inserir_token
   */
  TOKEN: 'modal_inserir_token',
  /**
   * modal_change_card
   */
  CHANGE_CARD: 'modal_change_card',
  /**
   * Confirmar email na aws
   *
   * modal_validar_email
   */
  VALIDAR_EMAIL: 'modal_validar_email',
  /**
   * modal_remove_contas_vinculadas
   */
  REMOVE_LINKED_ACCOUNT: 'modal_remove_contas_vinculadas',
  /**
   * modal_registrar_ativo
   */
  REGISTRAR_ATIVO: 'modal_registrar_ativo',
  /**
   * modal_vincular_conta
   */
  MERGE_ACCOUNT: 'modal_vincular_conta',
  /**
   * modal_enviar_push
   */
  SEND_PUSH: 'modal_enviar_push',
  /**
   * modal_enviar_link
   */
  SEND_LINK: 'modal_enviar_link',
  /**
   * modal_adicionar_subclasse_estrategica
   */
  ADD_SUBCLASS: 'modal_adicionar_subclasse_estrategica',
  /**
   * modal_alterar_senha
   */
  CHANGE_PASSWORD: 'modal_alterar_senha',
  /**
   * modal_register_professional
   */
  REGISTER_PROFESSIONAL: 'modal_register_professional',
  /**
   * modal_meus_dados
   */
  MEUS_DADOS: 'modal_meus_dados',
  /**
   * modal_extension_token
   */
  EXTENSION_TOKEN: 'modal_extension_token',
  // Canal WhatsApp da IA: o profissional vincula o número dele à conta
  // (aawz-intelligence-v2/modal/whatsapp-conectar).
  IA_WHATSAPP_CONECTAR: 'modal_ia_whatsapp_conectar',
  // Conectar as ferramentas SEM sair do chat — a etapa 3 do onboarding
  // (`plataforma/onboarding`) abre estes em vez de navegar para a tela do
  // módulo. Superfície NOVA: os modais de CRM > Integrações e de
  // Configurações > Atendimento seguem intactos e continuam sendo o caminho
  // de lá. Ver `aawz-intelligence-v2/constants/Conectores.js`.
  IA_CONECTAR_EMAIL_AGENDA: 'modal_ia_conectar_email_agenda',
  IA_CONECTAR_WHATSAPP: 'modal_ia_conectar_whatsapp',
  // 2º passo do WhatsApp — aberto pelo 1º ao criar a conexão, com
  // `{id_conexao, nome, tipo}`.
  IA_CONECTAR_WHATSAPP_QRCODE: 'modal_ia_conectar_whatsapp_qrcode',
  /**
   * modal_deletar_servico
   */
  DELETE_SERVICE: 'modal_deletar_servico',
  /**
   * modal_deletar_cliente
   */
  DELETE_CLIENT: 'modal_deletar_cliente',
  /**
   * modal_contratar_servico
   */
  CONTRATAR_SERVICO: 'modal_contratar_servico',
  /**
   * modal_open_cliente
   */
  OPEN_CLIENT: 'modal_open_cliente',
  /**
   * modal_adicionar_benchmark
   */
  ADD_BENCHMARK: 'modal_adicionar_benchmark',
  /**
   * modal_remover_ativo
   */
  REMOVE_ASSET: 'modal_remover_ativo',
  REMOVE_PRODUCT: 'modal_remover_produto',
  /**
   * modal_abrir_opcoes_movimentacao
   */
  MOVEMENTS_OPEN_OPTIONS: 'modal_abrir_opcoes_movimentacao',
  /**
   * modal_movimentacao_novo_provento
   */
  MOVEMENTS_NEW_PROFIT: 'modal_movimentacao_novo_provento',
  /**
   * modal_movimentacao_novo_split
   */
  MOVEMENTS_NEW_SPLIT: 'modal_movimentacao_novo_split',
  /**
   * modal_adicionar_conta_bancaria
   */
  ADD_BANK_ACCOUNT: 'modal_adicionar_conta_bancaria',
  /**
   * modal_ass_contrato
   */
  ASS_CONTRACT: 'modal_ass_contrato',
  /**
   * modal_detalhes_permissoes
   */
  SHOW_DETAILS_PERMISSIONS: 'modal_detalhes_permissoes',
  /**
   * modal_gerenciar_grupos
   */
  MANAGE_GROUPS: 'modal_gerenciar_grupos',
  /**
   * modal_receita_prox_mes
   */
  RECEITA_PROX_MES: 'modal_receita_prox_mes',
  /**
   * modal_accept_movements
   */
  ACCEPT_MOVEMENTS: 'modal_accept_movements',
  /**
   * modal_workspace_create_room
   */
  CREATE_ROOM: 'modal_workspace_create_room',
  /**
   * modal_dashboard_indicadores_filtro
   */
  DASHBOARD_INDICADORES_FILTRO: 'modal_dashboard_indicadores_filtro',
  /**
   * modal_acesso_clientes
   */
  ACESSO_CLIENTE: 'modal_acesso_clientes',
  /**
   * modal_suggest_improvement
   */
  SUGGEST_IMPROVEMENT: 'modal_suggest_improvement',
  /**
   * modal_editar_observacao
   */
  EDIT_OBSERVATION: 'modal_editar_observacao',
  /**
   * modal_send_comunicate
   */
  SEND_COMUNICATE: 'modal_send_comunicate',
  NEWS_DETAIL: 'modal_news_detail',
  /**
   * modal_bi_segmentacao_quadrantes
   */
  BI_SEGMENTACAO_QUADRANTES: 'modal_bi_segmentacao_quadrantes',
  /**
   * modal_bi_salvar_empresa
   */
  BI_SALVAR_EMPRESA: 'modal_bi_salvar_empresa',
  /**
   * modal_bi_salvar_senioridade
   */
  BI_SALVAR_SENIORIDADE: 'modal_bi_salvar_senioridade',
  /**
   * modal_bi_selecionar_plano_carreira
   */
  BI_SELECIONAR_PLANO_CARREIRA: 'modal_bi_selecionar_plano_carreira',
  /**
   * modal_bi_salvar_plano_carreira
   */
  BI_SALVAR_PLANO_CARREIRA: 'modal_bi_salvar_plano_carreira',
  /**
   * modal_bi_salvar_step_plano_carreira
   */
  BI_SALVAR_STEP_PLANO_CARREIRA: 'modal_bi_salvar_step_plano_carreira',
  /**
   * modal_bi_importar_planilha
   */
  BI_IMPORTAR_PLANILHA: 'modal_bi_importar_planilha',
  /**
   * modal_bi_salvar_documento
   */
  BI_SALVAR_DOCUMENTO: 'modal_bi_salvar_documento',
  /**
   * modal_bi_listar_documentos
   */
  BI_LISTAR_DOCUMENTOS: 'modal_bi_listar_documentos',
  /**
   * modal_bi_salvar_profissional
   */
  BI_SALVAR_PROFISSIONAL: 'modal_bi_salvar_profissional',
  /**
   * modal_bi_salvar_parametros_financeiros
   */
  BI_SALVAR_PARAMETROS_FINANCEIROS: 'modal_bi_salvar_parametros_financeiros',
  /**
   * modal_bi_expansao_incentivos
   */
  BI_EXPANSAO_INCENTIVOS: 'modal_bi_expansao_incentivos',
  /**
   * modal_bi_expansao_metas
   */
  BI_EXPANSAO_METAS: 'modal_bi_expansao_metas',
  /**
   * modal_bi_expansao_metas_profissionais
   */
  BI_EXPANSAO_METAS_PROFISSIONAIS: 'modal_bi_expansao_metas_profissionais',
  /**
   * modal_bi_salvar_dre_efetivada
   */
  BI_SALVAR_DRE_EFETIVADA: 'modal_bi_salvar_dre_efetivada',
  /**
   * modal_bi_salvar_contratacao
   */
  BI_SALVAR_CONTRATACAO: 'modal_bi_salvar_contratacao',
  /**
   * modal_bi_listar_contratacoes
   */
  BI_LISTAR_CONTRATACOES: 'modal_bi_listar_contratacoes',
  /**
   * modal_bi_aprovar_metas_profissionais
   */
  BI_APROVAR_METAS_PROFISSIONAIS: 'modal_bi_aprovar_metas_profissionais',
  /**
   * modal_bi_multiplo_valuation
   */
  BI_MULTIPLO_VALUATION: 'modal_bi_multiplo_valuation',
  /**
   * modal_bi_salvar_custo_adicional
   */
  BI_SALVAR_CUSTO_ADICIONAL: 'modal_bi_salvar_custo_adicional',
  /**
   * modal_bi_simular_contratacao
   */
  BI_SIMULAR_CONTRATACAO: 'modal_bi_simular_contratacao',
  /**
   * modal_bi_professionals_missing_data
   */
  BI_PROFESSIONALS_MISSING_DATA: 'modal_bi_professionals_missing_data',
  /**
   * modal_bi_view_import_historic
   */
  BI_VIEW_IMPORT_HISTORIC: 'modal_bi_view_import_historic',
  /**
   * modal_apply_hiring_plan_comissions
   */
  BI_APPLY_HIRING_PLAN_COMISSIONS: 'modal_apply_hiring_plan_comissions',
  /**
   * modal_pagarme_cobranca_detalhes
   */
  PAGARME_COBRANCA_DETALHAR: 'modal_pagarme_cobranca_detalhes',
  /**
   * modal_show_product
   */
  SHOW_PRODUCT: 'modal_show_product',
  /**
   * modal_resgate_total_contas_automaticas
   */
  RESGATE_TOTAL: 'modal_resgate_total_contas_automaticas',
  /**
   * modal_tour_temporario
   */
  TOUR_TEMPORARIO: 'modal_tour_temporario',
  /**
   * left_action
   */
  LEFT_ACTION: 'left_action',
  /**
   * modal_workspace_add_integrante
   */
  WORKSPACE_ADD_INTEGRANTE: 'modal_workspace_add_integrante',
  /**
   * modal_workspace_send_component
   */
  WORKSPACE_SEND_COMPONENT: 'modal_workspace_send_component',
  /**
   * modal_new_professional
   */
  NEW_PROFESSIONAL: 'modal_new_professional',
  /**
   * modal_minha_carteira
   */
  MODAL_MY_WALLET: 'modal_minha_carteira',
  /**
   * modal_carteira_analise
   */
  MODAL_WALLET_ANALYSIS: 'modal_carteira_analise',
  /**
   * modal_simulador_analise
   */
  MODAL_SIMULATOR_ANALYSIS: 'modal_simulador_analise',
  /**
   * modal_simulador_comparativo
   */
  MODAL_SIMULATOR_COMPARE: 'modal_simulador_comparativo',
  /**
   * modal_consentir_crawler_diario
   */
  CONSENTIR_CRAWLER_DIARIO: 'modal_consentir_crawler_diario',
  /**
   * modal_profissionais_atrelados
   */
  PROFISSIONAIS_ATRELADOS: 'modal_profissionais_atrelados',
  /**
   * modal_servicos_e_pagamentos
   */
  SERVICOS_PAGAMENTOS: 'modal_servicos_e_pagamentos',
  /**
   * modal_resumo_cliente
   */
  MODAL_RESUMO_CLIENTE: 'modal_resumo_cliente',
  /**
   * open_send_component
   */
  OPEN_SEND_COMPONENT: 'open_send_component',
  /**
   * modal_nova_pagina_modelo_pdf
   */
  NEW_PAGE_MODEL_PDF: 'modal_nova_pagina_modelo_pdf',
  /**
   * modal_selecionar_modelo_pdf
   */
  SELECT_PDF_MODEL: 'modal_selecionar_modelo_pdf',
  /**
   * modal_resgatar_pagarme
   */
  PAGARME_RESGATE: 'modal_resgatar_pagarme',
  /**
   * modal_show_release_notes
   */
  RELEASE_NOTES: 'modal_show_release_notes',
  /**
   * modal_adicionar_ativos_carteira_recomendada
   */
  ADD_ATIVOS_CARTEIRA_RECOMENDADA:
    'modal_adicionar_ativos_carteira_recomendada',
  /**
   * modal_salvar_ativo_carteira_recomendada
   */
  SALVAR_ATIVO_CARTEIRA_RECOMENDADA: 'modal_salvar_ativo_carteira_recomendada',
  /**
   * modal_selecionar_carteira_recomendada
   */
  SELECIONAR_CARTEIRA_RECOMENDADA: 'modal_selecionar_carteira_recomendada',
  /**
   * modal_show_release_notes_cliente
   */
  RELEASE_NOTES_CLIENTE: 'modal_show_release_notes_cliente',
  /**
   * modal_historico_pagarme
   */
  PAGARME_HISTORICO: 'modal_historico_pagarme',
  /**
   * modal_portabilidade
   */
  PORTABILIDADE: 'modal_portabilidade',
  /**
   * modal_settings_remover_ativo
   */
  SETTINGS_REMOVER_ATIVO: 'modal_settings_remover_ativo',
  /**
   * modal_dados_financeiros
   */
  FINANCIAL_DATA: 'modal_dados_financeiros',
  /**
   * modal_ver_dados_prospect
   */
  SEE_PROSPECT: 'modal_ver_dados_prospect',
  /**
   * modal_info_filtro_clientes
   */
  INFO_FILTER_CLIENTS: 'modal_info_filtro_clientes',
  /**
   * modal_dados_carteira_recomendada
   */
  DADOS_CARTEIRA_RECOMENDADA: 'modal_dados_carteira_recomendada',
  /**
   * modal_listar_documentos
   */
  LIST_DOCUMENTS: 'modal_listar_documentos',
  /**
   * modal_enviar_email
   */
  SEND_EMAIL: 'modal_enviar_email',
  /**
   * modal_indicacao
   */
  INDICACAO: 'modal_indicacao',
  /**
   * modal_change_class
   */
  CHANGE_CLASS: 'modal_change_class',
  /**
   * modal_settings_editar_ativo
   */
  SETTINGS_EDIT_ASSET: 'modal_settings_editar_ativo',
  /**
   * modal_settings_blacklist_fundos
   */
  SETTINGS_BLACKLIST_FUNDOS: 'modal_settings_blacklist_fundos',
  /**
   * modal_settings_blacklist_rf
   */
  SETTINGS_BLACKLIST_RF: 'modal_settings_blacklist_rf',
  /**
   * modal_filtro_controle_clientes
   */
  FILTER_CONTROL_CLIENTS: 'modal_filtro_controle_clientes',
  /**
   * modal_settings_importar_planilhas
   */
  SETTINGS_OPEN_SHEET_IMPORT: 'modal_settings_importar_planilhas',
  /**
   * modal_vincular_ativo_escolher
   */
  VINCULAR_ATIVO_ESCOLHER: 'modal_vincular_ativo_escolher',
  /**
   * modal_settings_daily_tasks
   */
  SETTING_DAILY_TASKS: 'modal_settings_daily_tasks',
  /**
   * modal_adicionar_portfolio_modelo
   */
  ADD_PORTFOLIO_MODELO: 'modal_adicionar_portfolio_modelo',
  /**
   * modal_add_professionals_career
   */
  ADD_PROFESSIONALS_CAREER: 'modal_add_professionals_career',
  /**
   * modal_pesquisar_ativo_short
   */
  SEARCH_ASSET_SHORT: 'modal_pesquisar_ativo_short',
  /**
   * modal_pesquisar_ativo_long
   */
  SEARCH_ASSET_LONG: 'modal_pesquisar_ativo_long',
  /**
   * modal_simulador_editar_ativo
   */
  SIMULATOR_EDIT_ASSET: 'modal_simulador_editar_ativo',
  /**
   * modal_simulador_pesquisa_historico
   */
  SIMULATOR_SEARCH_HISTORY: 'modal_simulador_pesquisa_historico',
  /**
   * modal_simulador_mais_info
   */
  SIMULATOR_MORE_INFO: 'modal_simulador_mais_info',
  /**
   * modal_simulador_fixar_ativos_atuais
   */
  SIMULATOR_SET_ASSETS: 'modal_simulador_fixar_ativos_atuais',
  /**
   * modal_simulador_detalhes
   */
  SIMULATOR_DETAILS: 'modal_simulador_detalhes',
  /**
   * modal_simulador_comparativo_grupo
   */
  SIMULATOR_COMPARISON_GROUP: 'modal_simulador_comparativo_grupo',
  /**
   * modal_select_email_template
   */
  SELECT_EMAIL_TEMPLATE: 'modal_select_email_template',
  /**
   * modal_import_xp_sheet
   */
  IMPORT_XP_SHEET: 'modal_import_xp_sheet',
  /**
   * modal_acoes_lote_ativos_consolidador
   */
  ACOES_LOTE_ATIVOS_CONSOLIDADOR: 'modal_acoes_lote_ativos_consolidador',
  /**
   * modal_trocar_ativo
   */
  CHANGE_ASSET: 'modal_trocar_ativo',
  /**
   * modal_composicao_fundo
   */
  COMPOSICAO_FUNDO: 'modal_composicao_fundo',
  /**
   * modal_conversao_rating
   */
  CONVERSAO_RATING: 'modal_conversao_rating',
  /**
   * modal_assinatura_profissional
   */
  PROFESSIONAL_SIGNATURE: 'modal_assinatura_profissional',
  /**
   * modal_restricoes_simulador
   */
  VER_RESTRICOES: 'modal_restricoes_simulador',
  /**
   * modal_details_asset
   */
  DETAILS_ASSET: 'modal_details_asset',
  /**
   * modal_edit_service
   */
  EDIT_SERVICE: 'modal_edit_service',
  /**
   * Close Modals Asset
   */
  CLOSE_MODALS_ASSET: 'close_modals_assets',
  /**
   * modal_template_email
   */
  TEMPLATE_EMAIL: 'modal_template_email',
  /**
   * modal_ver_mais_servico
   */
  SEE_MORE_SERVICE: 'modal_ver_mais_servico',
  /**
   * modal_save_revenue_area
   */
  FINANCIAL_SAVE_REVENUE_AREA: 'modal_save_revenue_area',
  /**
   * modal_financial_select_rubrics
   */
  FINANCIAL_SELECT_RUBRICS: 'modal_financial_select_rubrics',
  /**
   * modal_save_metrics
   */
  FINANCIAL_SAVE_METRICS: 'modal_save_metrics',
  /**
   * modal_save_categories
   */
  FINANCIAL_SAVE_CATEGORIES: 'modal_save_categories',
  /**
   * modal_finance_save_professional
   */
  FINANCIAL_SAVE_PROFESSIONAL: 'modal_finance_save_professional',
  /**
   * modal_bi_selecionar_participacao_societaria
   */
  BI_SELECT_PARTICIPATION: 'modal_bi_selecionar_participacao_societaria',
  /**
   * modal_bi_open_save_extern_agent
   */
  BI_OPEN_SAVE_EXTERN_AGENT: 'modal_bi_open_save_extern_agent',
  /**
   * modal_bi_save_filial
   */
  BI_SAVE_FILIAL: 'modal_bi_save_filial',
  /**
   * modal_bi_profissionais_filiais
   */
  BI_PROFESSIONALS_FILIALS: 'modal_bi_profissionais_filiais',
  /**
   * modal_docs_save_documents
   */
  DOCS_SAVE_DOCUMENTS: 'modal_docs_save_documents',
  /**
   * modal_docs_import_external_contract
   */
  DOCS_IMPORT_EXTERNAL_CONTRACT: 'modal_docs_import_external_contract',
  /**
   * modal_docs_save_templates
   */
  DOCS_SAVE_TEMPLATES: 'modal_docs_save_templates',
  /**
   * modal_docs_view_signers
   */
  DOCS_VIEW_SIGNERS: 'modal_docs_view_signers',
  /**
   * modal_docs_reload_document
   */
  DOCS_RELOAD_DOCUMENT: 'modal_docs_reload_document',
  /**
   * modal_docs_notify_signers
   */
  DOCS_NOTIFY_SIGNERS: 'modal_docs_notify_signers',
  /**
   * modal_docs_reload_doc_signers
   */
  DOCS_RELOAD_DOC_SIGNERS: 'modal_docs_reload_doc_signers',
  /**
   * modal_portfolio_save_fee_model
   */
  PORTFOLIO_SAVE_FEE_MODEL: 'modal_portfolio_save_fee_model',
  /**
   * modal_transfer_client
   */
  PARTNERSHIP_TRANSFER_CLIENT: 'modal_transfer_client',
  /**
   * modal_portfolio_attach_fee_model
   */
  PORTFOLIO_ATTACH_FEE_MODEL: 'modal_portfolio_attach_fee_model',
  /**
   * open_portfolio_mark_fee_paid_modal
   * Modal unico para marcar fee como pago e reabrir periodo (diferenciados por actionType no payload).
   */
  PORTFOLIO_MARK_FEE_PAID: 'open_portfolio_mark_fee_paid_modal',
  /**
   * modal_finance_manual_cash
   */
  FINANCE_MANUAL_CASH: 'modal_finance_manual_cash',
  /**
   * modal_finance_save_manual_cash
   */
  FINANCE_SAVE_MANUAL_CASH: 'modal_finance_save_manual_cash',
  /**
   * modal_professionals_edit_batch
   */
  PROFESSIONALS_EDIT_BATCH: 'modal_professionals_edit_batch',
  /**
   * modal_bi_save_data_room_file
   */
  BI_SAVE_DATA_ROOM_FILE: 'modal_bi_save_data_room_file',
  /**
   * modal_partnership_save_data_room_diary
   */
  PARTNERSHIP_SAVE_DATA_ROOM_DIARY: 'modal_partnership_save_data_room_diary',
  /**
   * professional_modal_active_user
   */
  PROFESSIONAL_MODAL_ACTIVE_USER: 'professional_modal_active_user',
  /*
   * modal_daily_tasks_assign
   */
  MODAL_DAILY_TASKS_ASSIGN: 'modal_daily_tasks_assign',
  /**
   * modal_daily_tasks_import
   */
  MODAL_DAILY_TASKS_IMPORT: 'modal_daily_tasks_import',
  /**
   * modal_teams_settings
   */
  MODAL_TEAMS_SETTINGS: 'modal_teams_settings',
  /**
   * modal_mirrored_access - acesso espelhado entre profissionais
   */
  MIRRORED_ACCESS: 'modal_mirrored_access',
  /**
   * modal_professional_clients_import
   */
  MODAL_PROFESSIONAL_CLIENTS_IMPORT: 'modal_professional_clients_import',
  /**
   * modal_professional_export
   */
  MODAL_PROFESSIONAL_EXPORT: 'modal_professional_export',
  /**
   * modal_professional_churn_list
   */
  MODAL_PROFESSIONAL_CHURN_LIST: 'modal_professional_churn_list',
  /**
   * modal_professional_churn_register
   */
  MODAL_PROFESSIONAL_CHURN_REGISTER: 'modal_professional_churn_register',
  /**
   * modal_partnership_bi_register
   */
  MODAL_PARTNERSHIP_BI_REGISTER: 'modal_partnership_bi_register',
  /**
   * modal_absent_professionals
   */
  MODAL_ABSENT_PROFESSIONALS: 'modal_absent_professionals',
  /**
   * CUSTOMERS_PARTNER_EDIT_BATCH
   */
  CUSTOMERS_PARTNER_EDIT_BATCH: 'CUSTOMERS_PARTNER_EDIT_BATCH',
  /**
   * modal_open_benchmark_composition
   */
  BENCHMARK_COMPOSITION: 'modal_open_benchmark_composition',
  /**
   * modal_create_family_group
   */
  MODAL_CREATE_FAMILY_GROUP: 'modal_create_family_group',
  /**
   * modal_send_maturities
   */
  MODAL_SEND_MATURITIES: 'modal_send_maturities',
  /**
   * modal_rubric
   */
  MODAL_RUBRIC: 'modal_rubric',
  /**
   * corporate_pool
   */
  CORPORATE_POOL: 'corporate_pool',
  /**
   * modal_departments
   */
  MODAL_DEPARTMENTS: 'modal_departments',
  /**
   * extract_cash
   */
  EXTRACT_CASH: 'extract_cash',
  /**
   * modal_send_notify_pending
   */
  MODAL_SEND_NOTIFY_PENDING: 'modal_send_notify_pending',
  /**
   * Módulo Documents — modal "Enviar lote pendente" (compliance).
   * Confirma o disparo, em um clique, de cada documento acumulado aguardando
   * envio para assinatura na Clicksign, agrupado por signatário (um envelope
   * por `email_signatario`). Payload: `{ lotes, total_documentos }` — a lista
   * já vem carregada pela `documents-overview` via
   * `GET /envelope/pendentes`; o modal não recarrega sozinho ao abrir.
   * Separado do `MODAL_SEND_NOTIFY_PENDING` (que serve qualquer documento,
   * escolhidos manualmente por profissional) — decisão de produto: os dois
   * fluxos coexistem, sem substituição.
   */
  DOCS_SEND_PENDING_BATCH: 'modal_docs_send_pending_batch',
  /**
   * Sinal para a `documents-overview` recarregar o contador/lista de lotes
   * pendentes (`GET /envelope/pendentes`) após o envio no
   * `DOCS_SEND_PENDING_BATCH`. Sem payload.
   */
  DOCS_RELOAD_PENDING_BATCH: 'modal_docs_reload_pending_batch',
  /**
   * modal_finance_table_professionals
   */
  MODAL_FINANCE_TABLE_PROFESSIONALS: 'modal_finance_table_professionals',
  /**
   * modal_purchase_options
   */
  PURCHASE_OPTIONS: 'modal_purchase_options',
  /**
   * modal_seniority
   */
  MODAL_SENIORITY: 'modal_seniority',
  /**
   * modal_create_permissions
   */
  MODAL_CREATE_PERMISSIONS: 'modal_create_permissions',
  /**
   * modal_import_suitability
   */
  MODAL_IMPORT_SUITABILITY: 'modal_import_suitability',
  /**
   * modal_create_boletador
   */
  MODAL_CREATE_BOLETADOR: 'modal_create_boletador',
  /**
   * modal_create_opportunities
   */
  MODAL_CREATE_OPPORTUNITIES: 'modal_create_opportunities',
  /**
   * modal_create_calendar
   */
  MODAL_CREATE_CALENDAR: 'modal_create_calendar',
  /**
   * modal_rules
   */
  MODAL_RULES: 'modal_rules',
  /**
   * modal_rules_alert_update
   */
  MODAL_RULES_ALERT_UPDATE: 'modal_rules_alert_update',
  /**
   * modal_template_data_room
   */
  MODAL_TEMPLATE_DATA_ROOM: 'modal_template_data_room',
  /**
   * modal_create_embed_bi
   */
  MODAL_CREATE_EMBED_BI: 'modal_create_embed_bi',
  /**
   * modal_batch_upload_boletador
   */
  MODAL_BATCH_UPLOAD_BOLETADOR: 'modal_batch_upload_boletador',
  /**
   * modal_create_quotas
   */
  MODAL_CREATE_QUOTAS: 'modal_create_quotas',
  /**
   * modal_payment_quotas
   */
  MODAL_PAYMENT_QUOTAS: 'modal_payment_quotas',
  /**
   * modal_list_payment_quotas
   */
  MODAL_LIST_PAYMENT_QUOTAS: 'modal_list_payment_quotas',
  /**
   * modal_import_option_quotas
   */
  MODAL_IMPORT_OPTION_QUOTAS: 'modal_import_option_quotas',
  /**
   * modal_captable_fees
   */
  MODAL_CAPTABLE_FEES: 'modal_captable_fees',
  /**
   * modal_list_stocks
   */
  MODAL_LIST_STOCKS: 'modal_list_stocks',
  /**
   * open_bills_to_receive
   */
  OPEN_BILLS_TO_RECEIVE: 'open_bills_to_receive',

  /**
   * open_professional_modal
   */
  OPEN_PROFESSIONAL_MODAL: 'open_professional_modal',
  /**
   * modal_create_campaign
   */
  MODAL_CREATE_CAMPAIGN: 'modal_create_campaign',
  /**
   * modal_manager_campaign
   */
  MODAL_MANAGER_CAMPAIGN: 'modal_manager_campaign',
  /**
   * modal_manager_participants
   */
  MODAL_MANAGER_PARTICIPANTS: 'modal_manager_participants',
  /**
   * modal_participants_campaign
   */
  MODAL_PARTICIPANTS_CAMPAIGN: 'modal_participants_campaign',
  /**
   * upload_campaign_sheet
   */
  UPLOAD_CAMPAIGN_SHEET: 'upload_campaign_sheet',
  /**
   * modal_alert_team_inactive
   */
  MODAL_ALERT_TEAM_INACTIVE: 'modal_alert_team_inactive',
  /**
   * modal_alert_revenues_areas
   */
  MODAL_ALERT_REVENUES_AREAS: 'modal_alert_revenues_areas',
  /**
   * modal_additional_info_team_inactive
   */
  MODAL_ADDITIONAL_INFO_TEAM_INACTIVE: 'modal_additional_info_team_inactive',
  /**
   * modal_additional_info_area_inactive
   */
  MODAL_ADDITIONAL_INFO_AREA_INACTIVE: 'modal_additional_info_area_inactive',
  /**
   * welcome_juridico
   */
  WELCOME_JURIDICO: 'welcome_juridico',
  /**
   * explain_img
   */
  EXPLAIN_IMG: 'explain_img',
  /**
   * modal_end_tour
   */
  MODAL_END_TOUR: 'modal_end_tour',
  /**
   * global_notify_news
   */
  GLOBAL_NOTIFY_NEWS: 'global_notify_news',
  /**
   * release_announcement
   */
  RELEASE_ANNOUNCEMENT: 'release_announcement',
  /**
   * open_warning_general_filials
   */
  OPEN_WARNING_GENERAL_FILIALS: 'open_warning_general_filials',
  /**
   * open_warning_additional_general_filials
   */
  OPEN_WARNING_ADDITIONAL_GENERAL_FILIALS:
    'open_warning_additional_general_filials',
  /**
   * open_warning_general_cnpjs
   */
  OPEN_WARNING_GENERAL_CNPJS: 'open_warning_general_cnpjs',
  /**
   * open_warning_additional_general_cnpjs
   */
  OPEN_WARNING_ADDITIONAL_GENERAL_CNPJS:
    'open_warning_additional_general_cnpjs',
  /**
   * open_save_version
   */
  OPEN_SAVE_VERSION: 'open_save_version',
  /**
   * modal_save_dre_version
   */
  MODAL_SAVE_DRE_VERSION: 'modal_save_dre_version',
  /**
   * open_period_select_finance
   */
  OPEN_PERIOD_SELECT_FINANCE: 'open_period_select_finance',
  /**
   * open_lote_shet_select_finance
   */
  OPEN_LOTE_SHEET_SELECT_FINANCE: 'open_lote_shet_select_finance',
  /**
   * open_add_adjustment
   */
  OPEN_ADD_ADJUSTMENT: 'open_add_adjustment',

  /**
   * open_edit_valuation
   */
  OPEN_EDIT_VALUATION: 'open_edit_valuation',
  /**
   * open_add_minimum_commission
   */
  OPEN_MINIMUM_COMMISSION: 'open_minimum_commission',
  /**
   * open_field_change
   */
  OPEN_FIELD_CHANGE: 'open_field_change',
  /**
   * open_modal_field_change
   */
  ALERT_FIELD_CHANGE_DELETE: 'alert_field_change_delete',
  /**
   * comissoes_add_tax
   */
  COMISSOES_ADD_TAX: 'comissoes_add_tax',
  /**
   * comissoes_add_list_item
   */
  COMISSOES_ADD_LIST_ITEM: 'comissoes_add_list_item',
  /**
   * comissoes_details_rules
   */
  COMISSOES_DETAILS_RULES: 'comissoes_details_rules',
  /**
   * modal_dataroom_import_batch
   */
  DATAROOM_IMPORT_BATCH: 'modal_dataroom_import_batch',
  /**
   * add_spreads_sheet
   */
  ADD_SPREADS_SHEET: 'add_spreads_sheet',
  /**
   * modal_comissoes_feedback_sheet
   */
  COMISSOES_FEEDBACK_SHEET: 'modal_comissoes_feedback_sheet',
  /**
   * modal_comissoes_import_rules
   */
  COMISSOES_IMPORT_RULES: 'modal_comissoes_import_rules',
  /**
   * modal_comissoes_relatorio_comissoes
   */
  COMISSOES_RELATORIO_COMISSOES: 'modal_comissoes_relatorio_comissoes',
  /**
   * modal_selecionar_fechamento
   */
  SELECIONAR_FECHAMENTO: 'modal_selecionar_fechamento',
  /**
   * modal_comissoes_novo_fechamento
   */
  COMISSOES_NOVO_FECHAMENTO: 'modal_comissoes_novo_fechamento',
  /**
   * modal_comissoes_disponibilizar_fechamento
   */
  COMISSOES_DISPONIBILIZAR_FECHAMENTO:
    'modal_comissoes_disponibilizar_fechamento',
  /**
   * modal_comissoes_emails_questionamentos
   */
  COMISSOES_EMAIL_QUESTIONAMENTO: 'modal_comissoes_emails_questionamentos',
  /**
   * alert_confirm_commission_delete
   */
  ALERT_CONFIRM_COMMISSION_DELETE: 'alert_confirm_commission_delete',
  /**
   * alert_confirm_commission_delete_adjustment
   */
  ALERT_CONFIRM_COMMISSION_DELETE_ADJUSTMENT:
    'alert_confirm_commission_delete_adjustment',
  /**
   * alert_confirm_cotacao_moeda
   */
  ALERT_CONFIRM_COTACAO_MOEDA: 'alert_confirm_cotacao_moeda',
  /**
   * comissoes_add_type
   */
  COMISSOES_ADD_TYPE: 'comissoes_add_type',
  /**
   * modal_late_notify
   */
  MODAL_LATE_NOTIFY: 'modal_late_notify',
  /**
   * modal_comissoes_import_historic
   */
  COMISSOES_IMPORT_HISTORIC: 'modal_comissoes_import_historic',
  /**
   * modal_comissoes_import_historic_batch
   */
  COMISSOES_IMPORT_HISTORIC_BATCH: 'modal_comissoes_import_historic_batch',
  /**
   * modal_comissoes_comentarios
   */
  COMISSOES_COMENTARIOS: 'modal_comissoes_comentarios',
  /**
   * modal_comissoes_questionar_fechamento
   */
  COMISSOES_QUESTIONAR_FECHAMENTO: 'modal_comissoes_questionar_fechamento',
  /**
   * modal_comissoes_copy_reset_rules
   */
  COMISSOES_COPY_RESET_RULES: 'modal_comissoes_copy_reset_rules',
  /**
   * modal_comissoes_import_bank_details
   */
  COMISSOES_IMPORT_BANK_DETAILS: 'modal_comissoes_import_bank_details',
  /**
   * modal_comissoes_export_payments
   */
  COMISSOES_EXPORT_PAYMENTS: 'modal_comissoes_export_payments',
  /**
   * modal_comissoes_fechamento_status
   */
  COMISSOES_STATUS_FECHAMENTO: 'modal_comissoes_fechamento_status',
  /**
   * modal_comissoes_planilha_status
   */
  COMISSOES_STATUS_PLANILHA: 'modal_comissoes_planilha_status',
  /**
   * modal_comissoes_manual_validate
   */
  COMISSOES_MANUAL_VALIDATE: 'modal_comissoes_manual_validate',
  /**
   * modal_comissoes_professional_payments_details
   */
  COMISSOES_PAYMENTS_DETAILS: 'modal_comissoes_professional_payments_details',
  /**
   * modal_comissoes_import_lists
   */
  COMISSOES_IMPORT_LISTS: 'modal_comissoes_import_lists',
  /**
   * modal_comissoes_import_lists_confirm
   */
  COMISSOES_IMPORT_LISTS_CONFIRM: 'modal_comissoes_import_lists_confirm',
  /**
   * modal_comissoes_import_clients
   */
  COMISSOES_IMPORT_CLIENTS: 'modal_comissoes_import_clients',
  /**
   * modal_comissoes_save_de_para_clientes
   */
  COMISSOES_SAVE_DE_PARA_CLIENTES: 'modal_comissoes_save_de_para_clientes',
  /**
   * modal_mix_client_comments
   */
  MIX_CLIENT_COMMENTS: 'modal_mix_client_comments',
  /**
   * modal_mix_client
   */
  MIX_CLIENT: 'modal_mix_client',
  /**
   * import_area_produtos
   */
  IMPORT_AREA_PRODUTOS: 'import_area_produtos',
  /**
   * modal_consolidator_asset_event
   */
  CONSOLIDATOR_ASSET_EVENT: 'modal_consolidator_asset_event',
  /**
   * modal_consolidator_select_client
   */
  CONSOLIDATOR_SELECT_CLIENT: 'modal_consolidator_select_client',
  /**
   * global_error_data_room
   */
  GLOBAL_ERROR_DATA_ROOM: 'global_error_data_room',
  /**
   * modal_consolidador_isencao_fee
   */
  CONSOLIDADOR_ISENCAO_FEE: 'modal_consolidador_isencao_fee',
  /**
   * rh_create_form
   */
  RH_CREATE_FORM: 'rh_create_form',
  /**
   * alert_forms_rh
   */
  ALERT_FORMS_RH: 'alert_forms_rh',
  /**
   * alert_inactive_forms_rh
   */
  ALERT_INACTIVE_FORMS_RH: 'alert_inactive_forms_rh',
  /**
   * rh_confirm_action
   */
  RH_CONFIRM_ACTION: 'rh_confirm_action',
  /**
   * add_new_valuation
   */
  ADD_NEW_VALUATION: 'add_new_valuation',
  /**
   * valuation_finished
   */
  VALUATION_FINISHED: 'valuation_finished',
  /**
   * rh_apply_valuation
   */
  RH_APPLY_VALUATION: 'rh_apply_valuation',
  /**
   * delete_valuation_finished
   */
  DELETE_VALUATION_FINISHED: 'delete_valuation_finished',
  /**
   * modal_rh_resume_professional_valuation
   */
  MODAL_RH_RESUME_PROFESSIONAL_VALUATION:
    'modal_rh_resume_professional_valuation',
  /**
   * modal_indicator_history
   */
  MODAL_INDICATOR_HISTORY: 'modal_indicator_history',
  /**
   * modal_file_professional_valuation
   */
  MODAL_FILE_PROFESSIONAL_VALUATION: 'modal_file_professional_valuation',
  /**
   * modal_rh_create_indicator
   */
  MODAL_RH_CREATE_INDICATOR: 'modal_rh_create_indicator',
  /**
   * setting_add_edit_category_commission
   */
  SETTING_ADD_EDIT_CATEGORY_COMMISSION: 'setting_add_edit_category_commission',
  /**
   * modal_create_family_product
   */
  MODAL_CREATE_FAMILY_PRODUCT: 'modal_create_family_product',
  /**
   * modal_import_data_by_sheet
   */
  MODAL_IMPORT_DATA_BY_SHEET: 'modal_import_data_by_sheet',
  /**
   * modal_family_product
   */
  MODAL_FAMILY_PRODUCT: 'modal_family_product',
  /**
   * modal_inverted_logical_explanation
   */
  MODAL_INVERTED_LOGICAL_EXPLANATION: 'modal_inverted_logical_explanation',
  /**
   * modal_tesouraria_solicitations
   */
  MODAL_TESOURARIA_SOLICITATIONS: 'modal_tesouraria_solicitations',
  /**
   * modal_tesouraria_solicitations_actions
   */
  MODAL_TESOURARIA_SOLICITATIONS_ACTIONS:
    'modal_tesouraria_solicitations_actions',
  /**
   * modal_create_events
   */
  MODAL_CREATE_EVENTS: 'modal_create_events',
  /**
   * modal_create_events_invite
   */
  MODAL_CREATE_EVENTS_INVITE: 'modal_create_events_invite',
  /**
   * modal_captable_update_kit_partners
   */
  MODAL_CAPTABLE_UPDATE_KIT_PARTNERS: 'modal_captable_update_kit_partners',
  /**
   * modal_create_kit_partners
   */
  CREATE_KIT_PARTNERS: 'modal_create_kit_partners',
  /**
   * modal_create_tipo_kit_partners
   */
  MODAL_CREATE_TIPO_PARTNERS: 'modal_create_tipo_kit_partners',
  /**
   * modal_professional_kit_partners
   */
  PROFESSIONAL_KIT_PARTNERS: 'modal_professional_kit_partners',
  /**
   * modal_client_kit_partners
   */
  CLIENT_KIT_PARTNERS: 'modal_client_kit_partners',
  /**
   * modal_pj_kit_partners
   */
  MODAL_PJ_KIT_PARTNERS: 'modal_pj_kit_partners',
  /**
   * captable_pj_list_select
   */
  CAPTABLE_PJ_LIST_SELECT: 'captable_pj_list_select',
  /**
   * modal_rh_config_goals_default
   */
  RH_CONFIG_GOALS_DEFAULT: 'modal_rh_config_goals_default',
  /**
   * modal_global_progress_request_ia
   */
  GLOBAL_PROGRESS_REQUEST_IA: 'modal_global_progress_request_ia',
  /**
   * modal_global_global_chat_ia
   */
  GLOBAL_GLOBAL_CHAT_IA: 'modal_global_global_chat_ia',
  /**
   * modal_captable_batch_select_signers
   */
  CAPTABLE_BATCH_SELECT_SIGNERS: 'modal_captable_batch_select_signers',
  /**
   * modal_calendar_confirm_finish_task
   */
  CALENDAR_CONFIRM_FINISH_TASK: 'modal_calendar_confirm_finish_task',
  /**
   * back_office_extracts_uploaded
   */
  MODAL_BACK_OFFICE_EXTRACTS_UPLOADED: 'back_office_extracts_uploaded',
  /**
   * modal_home_save_external_links
   */
  HOME_SAVE_EXTERNAL_LINKS: 'modal_home_save_external_links',
  /**
   * modal_home_manage_external_links
   */
  HOME_MANAGE_EXTERNAL_LINKS: 'modal_home_manage_external_links',
  /**
   * back_office_update_assets
   */
  BACK_OFFICE_UPDATE_ASSETS: 'back_office_update_assets',
  /**
   * back_office_update_transfer
   */
  BACK_OFFICE_UPDATE_TRANSFER: 'back_office_update_transfer',
  /**
   * COMISSOES_FEEDBACK_RULES_SAVE_ERROR
   * Modal para exibir erros personalizados ao salvar regras
   */
  COMISSOES_FEEDBACK_RULES_SAVE_ERROR: 'comissoes_feedback_rules_save_error',
  /**
   * consolidator_history_correlations
   */
  CONSOLIDATOR_HISTORY_CORRELATIONS: 'consolidator_history_correlations',
  /**
   * consolidator_analisys_advanced
   */
  CONSOLIDATOR_ANALISYS_ADVANCED: 'consolidator_analisys_advanced',
  /**
   * modal_consolidator_filter_personalization
   */
  CONSOLIDATOR_FILTER_PERSONALIZATION:
    'modal_consolidator_filter_personalization',
  /**
   * modal_billing_system_overview
   */
  MODAL_BILLING_SYSTEM_OVERVIEW: 'modal_billing_system_overview',
  /**
   * modal_billing_system_overview_actions
   */ MODAL_BILLING_SYSTEM_OVERVIEW_ACTIONS:
    'modal_billing_system_overview_actions',
  /**
   * modal_billing_system_historico
   */
  MODAL_BILLING_SYSTEM_HISTORICO: 'modal_billing_system_historico',
  /**
   * modal_billing_system_familia
   */
  MODAL_BILLING_SYSTEM_FAMILIA: 'modal_billing_system_familia',
  MODAL_BILLING_SYSTEM_JUSTIFICATIVA: 'modal_billing_system_justificativa',
  MODAL_BILLING_SYSTEM_OBSERVACAO: 'modal_billing_system_observacao',
  MODAL_BILLING_SYSTEM_FAMILIA_PLATAFORMA: 'modal_billing_system_familia_plataforma',
  MODAL_BILLING_SYSTEM_SYNC_PREVIEW: 'modal_billing_system_sync_preview',
  /**
   * modal_billing_system_selecionar_mes
   */
  MODAL_BILLING_SYSTEM_SELECIONAR_MES: 'modal_billing_system_selecionar_mes',
  /**
   * modal_billing_system_nova_cobranca
   */
  MODAL_BILLING_SYSTEM_NOVA_COBRANCA: 'modal_billing_system_nova_cobranca',
  /**
   * modal_billing_system_editar_cobranca
   */
  MODAL_BILLING_SYSTEM_EDITAR_COBRANCA: 'modal_billing_system_editar_cobranca',
  /**
   * modal_billing_system_btg_operacoes
   */
  MODAL_BILLING_SYSTEM_BTG_OPERACOES: 'modal_billing_system_btg_operacoes',
  /**
   * modal_billing_system_btg_enviar
   */
  MODAL_BILLING_SYSTEM_BTG_ENVIAR: 'modal_billing_system_btg_enviar',
  /**
   * modal_billing_system_historico_envios
   */
  MODAL_BILLING_SYSTEM_HISTORICO_ENVIOS:
    'modal_billing_system_historico_envios',
  /**
   * modal_billing_system_btg_saldos
   */
  MODAL_BILLING_SYSTEM_BTG_SALDOS: 'modal_billing_system_btg_saldos',
  /**
   * comissoes_base_de_clientes
   */
  COMISSOES_BASE_DE_CLIENTES: 'comissoes_base_de_clientes',
  /**
   * comissoes_historico_regra
   */
  COMISSOES_HISTORICO_REGRA: 'comissoes_historico_regra',
  /**
   * modal_fp_pgbl
   */
  MODAL_FP_PGBL: 'modal_fp_pgbl',
  /*
   * modal_fp_name_simulation_pgbl
   */
  MODAL_FP_NAME_SIMULATION_PGBL: 'modal_fp_name_simulation_pgbl',
  /**
   * financial_planning_salvar_cenario
   */
  FINANCIAL_PLANNING_SALVAR_CENARIO: 'financial_planning_salvar_cenario',
  /**
   * comissoes_add_edit_gatilhos
   */
  COMISSOES_GATILHOS: 'comissoes_gatilhos',
  /**
   * crm_register_relationship
   */
  CRM_REGISTER_RELATIONSHIP: 'crm_register_relationship',
  /**
   * crm_funil_builder — builder kanban (criar/editar funil)
   */
  CRM_FUNIL_BUILDER: 'crm_funil_builder',
  /**
   * crm_funil_activity — modal de atividade (nova / reaproveitar)
   */
  CRM_FUNIL_ACTIVITY: 'crm_funil_activity',
  /**
   * crm_oportunidade_funil_builder — builder de funil de oportunidades
   */
  CRM_OPORTUNIDADE_FUNIL_BUILDER: 'crm_oportunidade_funil_builder',
  /**
   * crm_oportunidade_perda — modal de motivo de perda (marcar perdido)
   */
  CRM_OPORTUNIDADE_PERDA: 'crm_oportunidade_perda',
  /**
   * crm_lead_perda — modal de motivo de perda do lead (marcar perdido +
   * agenda retorno automático ao funil quando o motivo tem dias_retorno_funil)
   */
  CRM_LEAD_PERDA: 'crm_lead_perda',
  /**
   * crm_oportunidade_motivos — CRUD de motivos de perda do escritório
   */
  CRM_OPORTUNIDADE_MOTIVOS: 'crm_oportunidade_motivos',
  /**
   * crm_regua_builder — builder da régua de relacionamento (criar/editar)
   */
  CRM_REGUA_BUILDER: 'crm_regua_builder',
  /**
   * crm_regua_activity — modal de atividade da régua (nova / reaproveitar)
   */
  CRM_REGUA_ACTIVITY: 'crm_regua_activity',
  /**
   * crm_origem_modal
   */
  CRM_ORIGEM_MODAL: 'crm_origem_modal',
  /**
   * crm_client_regua_link
   */
  CRM_CLIENT_REGUA_LINK: 'crm_client_regua_link',
  /**
   * crm_new_lead
   */
  CRM_NEW_LEAD: 'crm_new_lead',
  /**
   * crm_add_client
   */
  CRM_ADD_CLIENT: 'crm_add_client',
  /**
   * crm_import_leads_batch
   */
  CRM_IMPORT_LEADS_BATCH: 'crm_import_leads_batch',
  /**
   * crm_opportunities
   */
  CRM_OPPORTUNITIES: 'crm_opportunities',
  /**
   * crm_bens_modal
   */
  CRM_BENS_MODAL: 'crm_bens_modal',
  /**
   * crm_motivo_perda — modal único de adicionar/editar motivo de perda
   * (Configurações > CRM > Motivos de Perda). Payload: { item } (item.id
   * presente => edição; ausente => criação).
   */
  CRM_MOTIVO_PERDA: 'crm_motivo_perda',
  /**
   * pgbl_select_ir_year
   */
  PGBL_SELECT_IR_YEAR: 'pgbl_select_ir_year',
  /**
   * crm_empresas_modal
   */
  CRM_EMPRESAS_MODAL: 'crm_empresas_modal',
  /**
   * crm_empresas_link_client_modal
   */
  CRM_EMPRESAS_LINK_CLIENT_MODAL: 'crm_empresas_link_client_modal',
  /**
   * crm_grupo_familiar_modal
   */
  CRM_GRUPO_FAMILIAR_MODAL: 'crm_grupo_familiar_modal',
  /**
   * crm_grupo_familiar_link_client_modal
   */
  CRM_GRUPO_FAMILIAR_LINK_CLIENT_MODAL: 'crm_grupo_familiar_link_client_modal',
  /**
   * Modal "Como o total do grupo é calculado" (carteira consolidada por grupo
   * familiar). Sem payload — o exemplo exibido é estático, não deriva do grupo
   * aberto: derivá-lo seria um segundo cálculo de estatística no frontend.
   */
  GROUP_TOTAL_EXPLAINER: 'group_total_explainer',
  /**
   * crm_lead_edit
   */
  CRM_LEAD_EDIT: 'crm_lead_edit',
  /**
   * crm_required_fields_modal — modal compacto exibindo só os campos
   * obrigatórios faltantes (agrupados por categoria), aberto ao bloquear
   * move de etapa/Ganho (422 + missing_fields[]). Ao salvar com sucesso,
   * chama onRetry() pra completar o move sem fricção.
   */
  CRM_REQUIRED_FIELDS_MODAL: 'crm_required_fields_modal',
  /**
   * crm_api4com_token — modal gestor de configuração do token da integração
   * API4Com (tela de Ligações). Montado uma vez no crm-nav-bar (Fase 7).
   */
  CRM_API4COM_TOKEN: 'crm_api4com_token',
  /**
   * crm_client_avatar_upload
   */
  CRM_CLIENT_AVATAR_UPLOAD: 'crm_client_avatar_upload',
  /**
   * crm_comment_step_change
   */
  CRM_COMMENT_STEP_CHANGE: 'crm_comment_step_change',
  /**
   * crm_comment_modal
   */
  CRM_COMMENT_MODAL: 'crm_comment_modal',
  /**
   * crm_link_funil_lead_modal
   */
  CRM_LINK_FUNIL_LEAD_MODAL: 'crm_link_funil_lead_modal',
  /**
   * crm_compose_email
   */
  CRM_COMPOSE_EMAIL: 'crm_compose_email',
  /**
   * crm_email_config
   */
  CRM_EMAIL_CONFIG: 'crm_email_config',
  /**
   * crm_google_integration (deprecated alias — kept for any unmigrated consumer; new code should use CRM_PROVIDERS_INTEGRATION)
   */
  CRM_GOOGLE_INTEGRATION: 'crm_providers_integration',
  /**
   * crm_providers_integration — modal unificado de integrações (Google + Microsoft)
   */
  CRM_PROVIDERS_INTEGRATION: 'crm_providers_integration',
  /**
   * crm_schedule_task_calendar
   */
  CRM_SCHEDULE_TASK_CALENDAR: 'crm_schedule_task_calendar',
  CRM_EDIT_DATETIME: 'crm_edit_datetime',
  /**
   * modal_ws_save_operation
   */
  WS_SAVE_OPERATION: 'modal_ws_save_operation',
  /**
   * modal_ws_complete_operation
   */
  WS_COMPLETE_OPERATION: 'modal_ws_complete_operation',
  /**
   * modal_ws_operation_details
   */
  WS_OPERATION_DETAILS: 'modal_ws_operation_details',
  /**
   * compliance_ips
   */
  COMPLIANCE_IPS: 'compliance_ips',
  /**
   * compliance_client_answers
   */
  COMPLIANCE_CLIENT_ANSWERS: 'compliance_client_answers',
  /**
   * compliance_ips_respostas
   */
  COMPLIANCE_IPS_RESPOSTAS: 'compliance_ips_respostas',
  /**
   * compliance_ips_answers
   */
  COMPLIANCE_IPS_ANSWERS: 'compliance_ips_answers',
  /**
   * compliance_kyc_answers
   */
  COMPLIANCE_KYC_ANSWERS: 'compliance_kyc_answers',
  /**
   * compliance_kyc_detail — painel completo de detalhe KYC/PLD v2 (RF-005).
   * Payload esperado: { id_cliente_app, callback? }.
   */
  COMPLIANCE_KYC_DETAIL: 'compliance_kyc_detail',
  /**
   * compliance_kyc_manual_review_dialog — diálogo de revisão manual KYC/PLD
   * (RF-009). Payload: { id_classification, criterion, record_ref, decision,
   * label, onSaved? }.
   */
  COMPLIANCE_KYC_MANUAL_REVIEW: 'compliance_kyc_manual_review_dialog',
  /**
   * compliance_kyc_criterion_detail — modal focado por critério KYC/PLD,
   * mostra os dados ricos do detail_payload restritos àquele critério.
   * Payload: { criterionKey, criterion, detailPayload, client }.
   */
  COMPLIANCE_KYC_CRITERION_DETAIL: 'compliance_kyc_criterion_detail',
  /**
   * compliance_risk_profile_detail
   */
  COMPLIANCE_RISK_PROFILE_DETAIL: 'compliance_risk_profile_detail',
  /**
   * crm_edit_value_time
   */
  CRM_EDIT_VALUE_TIME: 'crm_edit_value_time',
  /**
   * crm_edit_field — modal genérico de edição de 1 campo do painel de
   * resumo (lead-summary-card). Payload: { idClienteApp, entityType,
   * idLead, field, currentValue } — `field` é o descritor resolvido por
   * summaryEditableFields.getEditDescriptor. Substitui crm_edit_description
   * e crm_edit_fee_start_date (consolidados neste único modal).
   */
  CRM_EDIT_FIELD: 'crm_edit_field',
  /**
   * crm_edit_fee_model — abre modal para vincular um modelo de cobrança ao cliente
   */
  CRM_EDIT_FEE_MODEL: 'crm_edit_fee_model',
  /**
   * crm_custom_field_form
   */
  CRM_CUSTOM_FIELD_FORM: 'crm_custom_field_form',
  /**
   * crm_summary_layout_form — abre modal de customização do painel de resumo
   */
  CRM_SUMMARY_LAYOUT_FORM: 'crm_summary_layout_form',
  /**
   * crm_overview_layout_form — abre editor da aba Visão Geral (scope profissional/escritorio)
   */
  CRM_OVERVIEW_LAYOUT_FORM: 'crm_overview_layout_form',
  /**
   * crm_custom_fields_layout_form — abre o editor de layout de Campos
   * Personalizados (criar/reordenar/redimensionar/excluir) direto do modal
   * de Lead/Cliente, aba Dados do Cliente (só gestor)
   */
  CRM_CUSTOM_FIELDS_LAYOUT_FORM: 'crm_custom_fields_layout_form',
  /**
   * crm_campo_obrigatorio_picker — abre o picker de campos obrigatórios (Lead)
   * de uma etapa do funil ou de Ganho, payload { target, camposAtuais }
   */
  CRM_CAMPO_OBRIGATORIO_PICKER: 'crm_campo_obrigatorio_picker',
  /**
   * crm_evolucao_ampliar — abre em tela cheia o gráfico de rentabilidade/
   * patrimônio do bloco crm-evolucao. Payload { mode, dataRentabilidade,
   * dataPatrimonio } — snapshot no momento do clique (a seleção de
   * instituição/benchmark fica bloqueada pelo scrim enquanto o modal está
   * aberto, então não precisa reagir a mudança depois de aberto).
   */
  CRM_EVOLUCAO_AMPLIAR: 'crm_evolucao_ampliar',
  /**
   * crm_register_relationship_result — sub-modal de resultado/reagendamento
   * de uma régua-atividade vencida, aberto de dentro do
   * crm-register-relationship-modal. Payload { item, groupKey, resposta,
   * isReschedule, novaData, onConfirmResultado, onConfirmReagendamento } —
   * os dois `onConfirm*` são callbacks do modal pai (mantêm a regra de
   * negócio de quitação em cascata lá, ver crm/CLAUDE.md §5).
   */
  CRM_REGISTER_RELATIONSHIP_RESULT: 'crm_register_relationship_result',
  /**
   * compliance_link_form
   */
  COMPLIANCE_LINK_FORM: 'compliance_link_form',
  /**
   * compliance_notify_signers
   */
  COMPLIANCE_NOTIFY_SIGNERS: 'compliance_notify_signers',
  /**
   * compliance_documents_clients
   */
  COMPLIANCE_DOCUMENTS_CLIENTS: 'compliance_documents_clients',
  /**
   * compliance_aawz_drive
   */
  COMPLIANCE_AAWZ_DRIVE: 'compliance_aawz_drive',
  /**
   * ws_confirm_sell
   */
  WS_CONFIRM_SELL: 'modal_ws_confirm_sell',
  /**
   * ws_new_contribution
   */
  WS_NEW_CONTRIBUTION: 'modal_ws_new_contribution',
  /**
   * ws_swap_assets
   */
  WS_SWAP_ASSETS: 'modal_ws_swap_assets',
  /**
   * ws_solicitacao_nova — abre o wizard de nova solicitação da esteira
   * Backoffice em modal centralizado, a partir da lista.
   */
  WS_SOLICITACAO_NOVA: 'modal_ws_solicitacao_nova',
  /**
   * ws_operations_summary
   */
  WS_OPERATIONS_SUMMARY: 'modal_ws_operations_summary',
  /**
   * ws_partial_operation
   */
  WS_PARTIAL_OPERATION: 'modal_ws_partial_operation',
  /**
   * modal_ws_partial_sale
   */
  WS_PARTIAL_SALE: 'modal_ws_partial_sale',
  /**
   * modal_ws_partial_swap
   */
  WS_PARTIAL_SWAP: 'modal_ws_partial_swap',
  /**
   * modal_ws_conciliate_operation — abre o passo de conciliação manual de
   * uma operação contra o extrato do Consolidador (evolução das Operações).
   */
  WS_CONCILIATE_OPERATION: 'modal_ws_conciliate_operation',
  /**
   * modal_ws_push_batch — marca um lote de operações selecionadas como
   * "push enviado" ao cliente, com resumo por corretora.
   */
  WS_PUSH_BATCH: 'modal_ws_push_batch',
  /**
   * modal_ws_operation_attachment — anexo de autorização do cliente
   * (Tesouro Direto) exigido antes de marcar push como enviado.
   */
  WS_OPERATION_ATTACHMENT: 'modal_ws_operation_attachment',
  /**
   * modal_ws_account_event_details — detalhe de um evento da Conta
   * (dividendo, JSCP, lançamento futuro etc).
   */
  WS_ACCOUNT_EVENT_DETAILS: 'modal_ws_account_event_details',
  /**
   * modal_ws_save_onboarding — cadastro/edição de processo de onboarding
   * (abertura PF/PJ ou migração de conta) no Backoffice.
   */
  WS_SAVE_ONBOARDING: 'modal_ws_save_onboarding',
  /**
   * modal_ws_onboarding_details — acompanhamento (etapas/pendências) de um
   * processo de onboarding.
   */
  WS_ONBOARDING_DETAILS: 'modal_ws_onboarding_details',
  /**
   * modal_ws_save_migration — cadastro/edição (inclusive em lote) de
   * migração de conta no Backoffice.
   */
  WS_SAVE_MIGRATION: 'modal_ws_save_migration',
  /**
   * modal_ws_migration_details — acompanhamento de um processo de migração.
   */
  WS_MIGRATION_DETAILS: 'modal_ws_migration_details',
  /**
   * modal_ws_save_custody_transfer — solicitação de transferência de
   * custódia (entrada/saída, por ativo ou totalidade).
   */
  WS_SAVE_CUSTODY_TRANSFER: 'modal_ws_save_custody_transfer',
  /**
   * modal_ws_custody_transfer_details — acompanhamento de uma transferência
   * de custódia (dias úteis, previsão, ativos recusados).
   */
  WS_CUSTODY_TRANSFER_DETAILS: 'modal_ws_custody_transfer_details',
  /**
   * modal_ws_save_average_price — preenchimento/atualização de preço médio
   * por ativo do cliente.
   */
  WS_SAVE_AVERAGE_PRICE: 'modal_ws_save_average_price',
  /**
   * modal_ws_fee_billing_details — detalhe de status por cliente de um
   * lote de cobrança de taxas de administração.
   */
  WS_FEE_BILLING_DETAILS: 'modal_ws_fee_billing_details',
  /**
   * modal_ws_save_professional — cadastro do processo de cadastro do
   * profissional na corretora (dados básicos).
   */
  WS_SAVE_PROFESSIONAL: 'modal_ws_save_professional',
  /**
   * modal_ws_professional_details — acompanhamento do processo de cadastro
   * do profissional (compliance, documentos, contrato, boas-vindas).
   */
  WS_PROFESSIONAL_DETAILS: 'modal_ws_professional_details',
  /**
   * modal_ws_save_tranche — criação/edição de uma tranche (agrupamento de
   * operações para execução por partes, com data prevista e observação).
   */
  WS_SAVE_TRANCHE: 'modal_ws_save_tranche',
  /**
   * modal_ws_tranche_details — acompanhamento de uma tranche (operações
   * vinculadas, % executado, próxima execução, tarefa relacionada).
   */
  WS_TRANCHE_DETAILS: 'modal_ws_tranche_details',
  /**
   * modal_ws_save_client_swap — troca de titularidade de um cliente entre
   * profissionais do escritório (solicitação, com aprovação do gestor).
   */
  WS_SAVE_CLIENT_SWAP: 'modal_ws_save_client_swap',
  /**
   * modal_ws_client_swap_details — acompanhamento de uma troca de clientes
   * (etapas solicitada / aprovação do gestor / efetivada).
   */
  WS_CLIENT_SWAP_DETAILS: 'modal_ws_client_swap_details',
  /**
   * modal_ws_asset_details — visualização completa do ativo na base do WS
   * (informações cadastrais, rentabilidade, gráfico e brokers).
   */
  WS_ASSET_DETAILS: 'modal_ws_asset_details',
  /**
   * modal_export_data_commissions_bpo_bi
   */
  DATAROOM_EXPORT_COMMISSIONS_DATA_BPO_BI:
    'DATAROOM_EXPORT_COMMISSIONS_DATA_BPO_BI',
  /**
   * finance_offset_office
   */
  FINANCE_OFFSET_OFFICE: 'finance_offset_office',
  /**
   * compliance_points_profile
   */
  COMPLIANCE_POINTS_PROFILE: 'compliance_points_profile',
  /**
   * settings_points_questions_ips
   */
  SETTINGS_POINTS_QUESTIONS_IPS: 'settings_points_questions_ips',
  /**
   * modal_file_viewer
   */
  FILE_VIEWER: 'modal_file_viewer',
  /**
   * modal_rename_aawz_drive_file
   */
  RENAME_AAWZ_DRIVE_FILE: 'modal_rename_aawz_drive_file',
  /**
   * modal_avatar_upload
   */
  AVATAR_UPLOAD: 'modal:avatar-upload',
  /**
   * modal_settings_edit_assets_batch
   */
  SETTINGS_EDIT_ASSETS_BATCH: 'modal_settings_edit_assets_batch',
  /**
   * modal_settings_propagate_base_assets
   */
  SETTINGS_PROPAGATE_BASE_ASSETS: 'modal_settings_propagate_base_assets',
  /**
   * compliance_client_overview
   */
  COMPLIANCE_CLIENT_OVERVIEW: 'compliance_client_overview',
  /**
   * modal_avenue_import
   */
  AVENUE_IMPORT: 'modal-avenue-import',
  /**
   * requisicoes_details_modal
   */
  REQUISICOES_DETAILS: 'requisicoes_details_modal',
  /**
   * modal_compliance_config_form_client
   */
  COMPLIANCE_CONFIG_FORM_CLIENT: 'modal_compliance_config_form_client',
  CONTROLADORIA_NOVO_FECHAMENTO: 'controladoria_novo_fechamento',
  CONTROLADORIA_SINCRONIZAR_COMISSOES: 'controladoria_sincronizar_comissoes',
  CONTROLADORIA_EDITAR_LISTA: 'controladoria_editar_lista',
  CONTROLADORIA_FECHAR_VERSAO: 'controladoria_fechar_versao',
  CONTROLADORIA_REPLICAR_CONFIG: 'controladoria_replicar_config',
  CONTROLADORIA_RODAR_LOTE: 'controladoria_rodar_lote',
  CONTROLADORIA_IMPORTAR_LOTE: 'controladoria_importar_lote',
  CONTROLADORIA_STATUS_MOTOR_MENSAGEM: 'controladoria_status_motor_mensagem',
  CONTROLADORIA_RODAR_MOTOR: 'controladoria_rodar_motor',
  CONTROLADORIA_AVISOS_IMPORTACAO: 'controladoria_avisos_importacao',
  CONTROLADORIA_AREAS_DEPARTAMENTOS: 'controladoria_areas_departamentos',
  /**
   * modal_task_detail
   */
  TASK_DETAIL: 'modal_task_detail',
  /**
   * modal_task_folder_save
   */
  TASK_FOLDER_SAVE: 'modal_task_folder_save',
  /**
   * modal_task_privacy
   */
  TASK_PRIVACY: 'modal_task_privacy',
  /**
   * modal_task_sprint_save
   */
  TASK_SPRINT_SAVE: 'modal_task_sprint_save',
  /**
   * modal_task_sprint_copy (duplicar lista com preview e opcoes)
   */
  TASK_SPRINT_COPY: 'modal_task_sprint_copy',
  /**
   * modal_task_sprint_save_as_template (salvar lista como modelo de lista)
   */
  TASK_SPRINT_SAVE_AS_TEMPLATE: 'modal_task_sprint_save_as_template',
  /**
   * modal_task_list_template_picker (escolher modelo de lista — US-3; aberto a
   * qualquer profissional, disparado pela sidebar ao lado de "Nova lista")
   */
  TASK_LIST_TEMPLATE_PICKER: 'modal_task_list_template_picker',
  /**
   * modal_task_list_template_instantiate (instanciar modelo de lista em nova sprint)
   */
  TASK_LIST_TEMPLATE_INSTANTIATE: 'modal_task_list_template_instantiate',
  /**
   * modal_task_custom_fields_settings
   */
  TASK_CUSTOM_FIELDS_SETTINGS: 'modal_task_custom_fields_settings',
  /**
   * modal_task_solicitacao_aviso — convite para avisar o solicitante do WS ao
   * concluir um card originado de uma solicitação da esteira Backoffice.
   */
  TASK_SOLICITACAO_AVISO: 'modal_task_solicitacao_aviso',
  /**
   * modal_tag_form (tarefas tag CRUD)
   */
  TAG_FORM: 'modal_tag_form',
  /**
   * modal_tarefas_status_form (create/edit a folder status — gestor-only).
   * Opened from inside the "Editar pasta" modal (FolderStatusTable).
   */
  STATUS_FORM: 'modal_tarefas_status_form',
  /**
   * modal_template_form (tarefas template CRUD — gestor-only)
   */
  TAREFAS_TEMPLATE_FORM: 'modal_tarefas_template_form',
  /**
   * modal_template_instantiate (wizard de instanciacao de template)
   */
  TAREFAS_TEMPLATE_INSTANTIATE: 'modal_tarefas_template_instantiate',
  /**
   * modal_template_picker (lista de templates para escolher antes de instanciar)
   */
  TAREFAS_TEMPLATE_PICKER: 'modal_tarefas_template_picker',
  /**
   * modal_pm_trigger_mapping_form (CRUD de mapping evento↔template — gestor-only)
   */
  PM_TRIGGER_MAPPING_FORM: 'modal_pm_trigger_mapping_form',
  /**
   * modal_pm_trigger_suggester (wizard pós drag-to-Won — picker + instanciar)
   */
  PM_TRIGGER_SUGGESTER: 'modal_pm_trigger_suggester',
  /**
   * financial_planning_goal_detail
   */
  FINANCIAL_PLANNING_GOAL_DETAIL: 'financial_planning_goal_detail',
  /**
   * modal_atendimento_nova_conexao
   */
  ATENDIMENTO_NOVA_CONEXAO: 'modal_atendimento_nova_conexao',
  /**
   * modal_atendimento_termos
   */
  ATENDIMENTO_TERMOS: 'modal_atendimento_termos',
  /**
   * modal_atendimento_assign_profissionais
   */
  ATENDIMENTO_ASSIGN_PROFISSIONAIS: 'modal_atendimento_assign_profissionais',
  /**
   * modal_atendimento_qrcode_conexao
   */
  ATENDIMENTO_QRCODE_CONEXAO: 'modal_atendimento_qrcode_conexao',
  /**
   * modal_atendimento_instrucao_profissional
   */
  ATENDIMENTO_INSTRUCAO_PROFISSIONAL:
    'modal_atendimento_instrucao_profissional',
  /**
   * modal_atendimento_media_preview
   */
  ATENDIMENTO_MEDIA_PREVIEW: 'modal_atendimento_media_preview',
  /**
   * modal_atendimento_nova_conversa
   */
  ATENDIMENTO_NOVA_CONVERSA: 'modal_atendimento_nova_conversa',
  /**
   * modal_atendimento_importar_historico
   */
  ATENDIMENTO_IMPORTAR_HISTORICO: 'modal_atendimento_importar_historico',
  /**
   * modal_atendimento_transferir_conversa
   */
  ATENDIMENTO_TRANSFERIR_CONVERSA: 'modal_atendimento_transferir_conversa',
  /**
   * modal_atendimento_gerenciar_respostas
   */
  ATENDIMENTO_GERENCIAR_RESPOSTAS: 'modal_atendimento_gerenciar_respostas',
  /**
   * modal_atendimento_resposta_rapida
   */
  ATENDIMENTO_RESPOSTA_RAPIDA: 'modal_atendimento_resposta_rapida',
  /**
   * modal_atendimento_vincular_contato
   */
  ATENDIMENTO_VINCULAR_CONTATO: 'modal_atendimento_vincular_contato',
  /**
   * modal_atendimento_popup — abre o FAB de mini-atendimento.
   * Payload opcional: { id_cliente_app } — se fornecido, seleciona a conversa
   * vinculada ao cliente (ex.: botão "Falar no WhatsApp" na ficha do lead).
   */
  ATENDIMENTO_POPUP: 'modal_atendimento_popup',
  /**
   * atendimento_client_drive — abre o AAWZ Drive do cliente vinculado à
   * conversa (embrulha o componente AawzDrive). Payload: { item: { id_cliente_app, nome } }.
   */
  ATENDIMENTO_CLIENT_DRIVE: 'atendimento_client_drive',
  /**
   * modal_super_ranking_cycle
   */
  MODAL_SUPER_RANKING_CYCLE: 'modal_super_ranking_cycle',
  /**
   * modal_super_ranking_cluster
   */
  MODAL_SUPER_RANKING_CLUSTER: 'modal_super_ranking_cluster',
  /**
   * modal_super_ranking_indicator
   */
  MODAL_SUPER_RANKING_INDICATOR: 'modal_super_ranking_indicator',
  /**
   * modal_super_ranking_goal_weight
   */
  MODAL_SUPER_RANKING_GOAL_WEIGHT: 'modal_super_ranking_goal_weight',
  /**
   * modal_bi_create_tasks — abre modal para criar tarefas a partir de linhas do BI
   */
  BI_CREATE_TASKS: 'modal_bi_create_tasks',
  /**
   * Comunicação do módulo Solicitações — chaves PRÓPRIAS (não reusar as
   * ATENDIMENTO_*, senão o service captura eventos do WhatsApp real).
   */
  SOLICITACOES_COMUNICACAO_NOVA_CONVERSA:
    'modal_solicitacoes_comunicacao_nova_conversa',
  SOLICITACOES_COMUNICACAO_IMPORTAR_HISTORICO:
    'modal_solicitacoes_comunicacao_importar_historico',
  SOLICITACOES_COMUNICACAO_TRANSFERIR_CONVERSA:
    'modal_solicitacoes_comunicacao_transferir_conversa',
  SOLICITACOES_COMUNICACAO_GERENCIAR_RESPOSTAS:
    'modal_solicitacoes_comunicacao_gerenciar_respostas',
  SOLICITACOES_COMUNICACAO_RESPOSTA_RAPIDA:
    'modal_solicitacoes_comunicacao_resposta_rapida',
  SOLICITACOES_COMUNICACAO_QRCODE_CONEXAO:
    'modal_solicitacoes_comunicacao_qrcode_conexao',
  SOLICITACOES_COMUNICACAO_TERMOS: 'modal_solicitacoes_comunicacao_termos',
  /**
   * Módulo Central de IA (ai-framework, spec-002) — wizard de ativação (3 passos).
   * Payload: { slug }.
   */
  AI_FRAMEWORK_ACTIVATION_WIZARD: 'modal_ai_framework_activation_wizard',
  /**
   * Módulo Central de IA — modal "Configurar" de uma instância existente.
   * Payload: { instanceId }.
   */
  AI_FRAMEWORK_INSTANCE_CONFIG: 'modal_ai_framework_instance_config',
  /**
   * Módulo Central de IA — modal de migração de versão do template.
   * Payload: { instanceId }.
   */
  AI_FRAMEWORK_VERSION_MIGRATION: 'modal_ai_framework_version_migration',
  /**
   * Módulo Central de IA (spec-004) — modal de recusa de proposta (justificativa
   * obrigatória). Payload: { proposta } (PendingProposalItem).
   */
  AI_FRAMEWORK_APPROVAL_REJECT: 'modal_ai_framework_approval_reject',
  /**
   * Módulo Central de IA (spec-004) — drill read-only de uma execução (timeline do run
   * + decisão vinculada). Payload: { idRun }. Renderizado via BaseModal lateral (drawer).
   */
  AI_FRAMEWORK_RUN_DETAIL: 'modal_ai_framework_run_detail',
  /**
   * Módulo Central de IA — modal centralizado de créditos (Planos · Adicionar créditos ·
   * Uso), aberto de dentro do chat sem sair da página. Sem payload.
   */
  AI_FRAMEWORK_CREDITOS: 'modal_ai_framework_creditos',
}

export const WEBSOCKET = {
  WORKSPACE_MESSAGE: 'websocket_workspace_onmessage',
  WORKSPACE_RELOAD_MSG: 'websocket_workspace_reload_message',
}

/**
 * Espelho no GlobalBus de todo `$gtagEvent`. Existe para módulos que precisam
 * saber que uma ação de negócio foi CONCLUÍDA (hoje: a pesquisa de NPS) sem
 * acoplar cada handler a eles — o handler já emite o evento de telemetria.
 */
export const TELEMETRIA = {
  EVENTO: 'telemetria_evento',
}

export const ACTION = {
  MERGED_ASSET: 'merged_action_asset',
  COTIZAR_CLIENTE: 'run_cotizar_cliente',
  BI_SET_MODEL_SHEET: 'bi_set_model_sheet_import',
  BI_IMPORT_SHEET_CLEAR: 'bi_import_sheet_clear',
  SELECT_PDF_MODEL: 'modelo_pdf_selecionado',
  UPDATE_ASSET: 'atualizar_valores_ativo',
  SELECT_RUBRICS: 'financial_select_rubrics',
  COMMISSIONS_QUEST_APPROVE: 'commissions_quest_approve',
  DASHBOARD_CONFIG_FULL_SCREEN: 'dashboard_config_full_screen',
  DASHBOARD_CHANGE: 'dashboard-change',
  DASHBOARD_EXIT_FULLSCREEN: 'dashboard-exit-fullscreen',
  NAVBAR_HOVER_LOCK: 'nav-bar-hover-lock',
  ATENDIMENTO_CONVERSA_CRIADA: 'atendimento_conversa_criada',
  ATENDIMENTO_HISTORICO_IMPORTADO: 'atendimento_historico_importado',
  ATENDIMENTO_CONVERSA_TRANSFERIDA: 'atendimento_conversa_transferida',
  ATENDIMENTO_CONTATO_VINCULADO: 'atendimento_contato_vinculado',
  ATENDIMENTO_RESPOSTA_RAPIDA_SALVA: 'atendimento_resposta_rapida_salva',
  ATENDIMENTO_CONEXAO_CRIADA: 'atendimento_conexao_criada',
  ATENDIMENTO_CONEXAO_ATUALIZADA: 'atendimento_conexao_atualizada',
  ATENDIMENTO_CONEXAO_CONECTADA: 'atendimento_conexao_conectada',
  ATENDIMENTO_AUTO_LINK_RESOLVED: 'atendimento_auto_link_resolved',
  // Comunicação do módulo Solicitações — chaves PRÓPRIAS (clone desacoplado
  // do atendimento; não reusar as ATENDIMENTO_* para evitar regressão cruzada).
  SOLICITACOES_COMUNICACAO_CONVERSA_CRIADA:
    'solicitacoes_comunicacao_conversa_criada',
  SOLICITACOES_COMUNICACAO_HISTORICO_IMPORTADO:
    'solicitacoes_comunicacao_historico_importado',
  SOLICITACOES_COMUNICACAO_CONVERSA_TRANSFERIDA:
    'solicitacoes_comunicacao_conversa_transferida',
  SOLICITACOES_COMUNICACAO_RESPOSTA_RAPIDA_SALVA:
    'solicitacoes_comunicacao_resposta_rapida_salva',
  SOLICITACOES_COMUNICACAO_CONEXAO_ATUALIZADA:
    'solicitacoes_comunicacao_conexao_atualizada',
  SOLICITACOES_COMUNICACAO_CONEXAO_CONECTADA:
    'solicitacoes_comunicacao_conexao_conectada',
}

/**
 * Eventos do chat de IA disparados de FORA da árvore dele.
 *
 * Hoje só a busca global (Ctrl/Cmd+K) os emite, na visão imersiva `/ia`: lá o
 * palette virou o caminho para trocar de agente e reabrir conversa, e ele vive
 * em `global-modals.vue`, fora do `view-chat`. Chamar os métodos de lá seria
 * atravessar duas árvores; o bus é o contrato que o repo já usa para isso.
 *
 * ⚠️ Quem escuta é o `view-chat`, e SÓ na configuração imersiva. Duas
 * instâncias do chat no mesmo namespace disputam o stream (é o motivo de o
 * popup ser desligado na `/ia`) — assinar em todas faria a troca de agente
 * atingir uma instância que o usuário nem está vendo.
 */
export const CHAT_IA_EVENTOS = {
  ESCOLHER_AGENTE: 'chat-ia:escolher-agente',
  ABRIR_CONVERSA: 'chat-ia:abrir-conversa',
  /**
   * Conversa nova pedida de fora da tela do chat (palette da IA).
   *
   * Passa pelo bus em vez de a origem despachar as três actions direto porque
   * `novaConversa()` limpa o cliente em foco APENAS quando a superfície tem
   * seletor de escopo (`escopoDeCliente`) — a store é compartilhada com o popup
   * e o painel do Hub, e limpar de fora vazaria para eles.
   */
  NOVA_CONVERSA: 'chat-ia:nova-conversa',
  /**
   * Abre o popup da IA já com uma pergunta enviada (payload
   * `{ pergunta, enviar }`; `enviar` default true). `enviar: false` (só
   * preencher o composer) só funciona com o popup FECHADO: aberto, o
   * watcher do `ChatView` ignora troca de prop no modo prefill. Quem emite é uma tela de
   * outro módulo — o botão "Resumir não lidas" do Omnichannel é o primeiro —
   * e o único ouvinte é o `chat-ia-pop-up`, que é a superfície sempre montada
   * (`router/layouts/main.vue`). O modal global do chat só existe com o
   * popup aberto, por isso não serve de destino.
   */
  ABRIR_COM_PERGUNTA: 'chat-ia:abrir-com-pergunta',
  /**
   * Cliente do escopo escolhido no palette (o chip perdeu o dropdown na `/ia`).
   *
   * Pelo bus, e não por dispatch direto: `setClienteEscopo` só pode ser escrito
   * pela superfície que TEM seletor de escopo — a store é a mesma do popup e do
   * painel do Hub, e o `view-chat` gateia isso em `escopoDeCliente`. Payload é o
   * objeto do cliente, ou `null` para "Todo o escritório".
   */
  ESCOLHER_CLIENTE: 'chat-ia:escolher-cliente',
  /**
   * Devolve o cursor ao campo do composer. Quem escolhe algo no palette
   * terminou de decidir e vai ESCREVER — sem isto era preciso clicar na caixa.
   *
   * Canal próprio, e não um efeito colateral de cada canal acima, porque a
   * troca de MODELO não passa por bus nenhum (o palette despacha direto na
   * store) e mesmo assim precisa devolver o foco. Emitido uma vez por escolha,
   * depois da ação — ver `devolverFocoAoComposer` no `ia-palette.vue`.
   */
  FOCAR_COMPOSER: 'chat-ia:focar-composer',
  /**
   * Abre o seletor de arquivos do composer, pedido de fora dele (palette).
   *
   * Pelo bus, e não por `$refs` do palette até o composer: o palette é montado
   * em `global-modals.vue`, FORA da árvore do chat — não há referência a
   * atravessar. Mesmo caminho de `NOVA_CONVERSA`.
   *
   * Sem payload: o `send-message` é quem sabe se o anexo está liberado e se a
   * fila já está cheia, e ele já recusa nos outros dois gatilhos.
   */
  ANEXAR_ARQUIVOS: 'chat-ia:anexar-arquivos',
  /**
   * Um cartão respondeu de DENTRO do painel de artefato (spec-005, US-6).
   *
   * Pelo bus, e não por evento Vue até o `view-chat`: o `ArtefatoPainel` é
   * IRMÃO do `<ViewChat>` dentro da visão imersiva (`view-chat-imersivo.vue`),
   * e quem trata a resposta (`responderCartao`) mora no chat — não há relação
   * pai/filho entre os dois, e alcançar o método por `$refs` do irmão seria
   * pior: a assinatura pública passaria a ser um `$refs` que nada declara.
   * Mesmo caminho que `ESCOLHER_CLIENTE`/`NOVA_CONVERSA` já usam por serem
   * emitidos de fora da árvore do chat.
   *
   * ⚠️ Só a configuração imersiva assina (`assinarAtalhosDaBuscaGlobal`, que
   * já é gateada por `sidebarComoNavegacao`) — e ela é a ÚNICA superfície com
   * painel de artefato (`modoArtefatoAtivo`). Duas instâncias de chat no mesmo
   * namespace nunca coexistem (ver `router/layouts/main.vue`), então o bus não
   * tem como entregar a resposta a um chat que o usuário não está vendo.
   *
   * Payload: o mesmo envelope do canal genérico do contrato (§2),
   * `{parte, toolCallId, acao, payload}` — a `parte` viaja porque é pela
   * `chave` dela que o confirmador do MÓDULO é encontrado.
   */
  RESPONDER_CARTAO: 'chat-ia:responder-cartao',
}

export const RELOAD = {
  /**
   * Sinal de que uma transcrição mudou (cliente/projeto/nome/descrição/
   * participantes editados em um dos modais satélites de CRM > Transcrições).
   * Sem payload. Consumido pelo detalhe (recarrega silenciosamente via
   * pollDetail), pelo histórico, pelo omni-transcricoes e pelo painel de
   * transcrições recentes (navegacao-v2/profile-transcricoes). Movido de
   * MODAL.TRANSCRIPT_RELOAD (2026-09): não abre modal, é um broadcast de
   * reload — não pertence ao contrato de abertura MODAL.<NAME>.
   */
  TRANSCRIPT: 'reload_transcript',
  /**
   * Emitido pelo task-detail-form após criar uma tarefa vinculada a uma
   * mensagem do atendimento; o chat-window escuta para refrescar os badges.
   */
  ATENDIMENTO_TASK_LINKED: 'atendimento:task-linked',
  /**
   * Emitido após criar uma NOTA interna; a sidebar (client-detail-panel)
   * escuta para recarregar a lista de notas da conversa.
   */
  ATENDIMENTO_NOTAS: 'atendimento:notas-reload',
  IA_API_KEYS: 'reload_ia_api_keys',
  IA_CURADORIA: 'reload_ia_curadoria',
  BACK_OFFICE_DATA_ROOM: 'reload_data_room_back_office',
  BACK_OFFICE_ASSETS_OPERATIONS: 'reload_back_office_assets_operations',
  CLIENTS: 'reload_clients',
  CLIENT_CREATED: 'reload_client_created',
  CLIENTS_FILTER: 'reload_clients_filter',
  PROFESSIONALS: 'reload_professionals',
  SERVICES: 'reload_services',
  ASSETS: 'reload_assets',
  ASSETS_ONLY: 'reload_assets_only',
  EDIT_ASSET: 'reload_edited_asset',
  TEMPLATES_EMAIL: 'reload_templates_email',
  /**
   * Recarregar tabela de templates de tasks em /task/configuracoes/templates
   * após criar/editar/excluir ou salvar task como template.
   */
  TAREFAS_TEMPLATES: 'reload_tarefas_templates',
  /**
   * Recarregar tabela de trigger mappings em /task/configuracoes/automacoes
   * após criar/editar/excluir via modal de form.
   */
  PM_TRIGGER_MAPPINGS: 'reload_pm_trigger_mappings',
  ROOMS: 'reload_rooms',
  MOVEMENTS: 'reload_movements',
  ACCOUNT: 'reload_account',
  /**
   * changeClient
   */
  CHANGE_CLIENT: 'changeClient',
  CLIENT_DEFAULT: 'clientDefault',
  ACCESS_CLIENT: 'reload_access_client',
  BASE_ASSETS: 'reload_base_ativos',
  SEND_LINK: 'reload_send_link',
  ATT_BANKS: 'atualizandoBancos',
  FINANCIAL_DATA: 'reload_financial_data',
  DASHBOARD_DATA: 'reload_dashboard_data',
  CONTRACTS: 'reload_contracts',
  PROFESSIONAL_SIGNATURE: 'reload_assinatura_profissional',
  PORTFOLIOS: 'reload_portfolio_modelo',
  SIM_RUNNING: 'check_reload_sim_running',
  VALIDATE_EMAIL: 'reload_emails',
  IPS_ANSWERS: 'reload_ips_answers',
  SETTINGS_SHEETS: 'reload_settings_sheets',
  MOVEMENTS_MODAL: 'reload_movements_modal',
  CHAMADOS_NOVOS: 'reload_chamados_novos',
  CHAMADOS_ABERTOS: 'reload_chamados_abertos',
  CHAMADOS_HISTORICO: 'reload_chamados_historico',
  MANAGE_BENCHMARKS: 'reload_manage_benchmark',
  CARTEIRAS_RECOMENDADAS: 'reload_carteiras_recomendadas',
  ATIVOS_CARTEIRA_RECOMENDADA: 'reload_ativos_carteira_recomendada',
  CONSOLIDATOR_ASSET_EVENT: 'reload_consolidator_asset_event',
  BI_DOCUMENTS: 'reload_bi_documents',
  CRM_CUSTOM_FIELDS: 'reload_crm_custom_fields',
  BI_FINANCEIRO_UNICO: 'reload_bi_financeiro_unico',
  BI_FINANCEIRO_CONVERSAO: 'reload_bi_financeiro_conversao',
  BI_FINANCEIRO_COMISSAO: 'reload_bi_financeiro_comissao',
  BI_PARAMETROS_INCENTIVOS: 'reload_bi_parametros_incentivos',
  FINANCIAL_METRICS_PJ: 'reload_financial_metrics_pj',
  FINANCIAL_METRICS_FILIAL: 'reload_financial_metrics_filial',
  FINANCIAL_METRICS_AREAS: 'reload_financial_metrics_areas',
  CLIENTS_FEE_MODEL: 'reload_clients_fee_model',
  DATA_ROOM_FILES: 'reload_data_room_files',
  BI_PARTNERSHIPS_PJ: 'reload_partnerships_pjs',
  SOLICITATIONS_CLOSE_MODAL: 'solicitations_close_modal',
  SOLICITATIONS: 'reload_solicitations',
  BILLING_SYSTEM_OVERVIEW: 'billing_system_overview',
  BILLING_SYSTEM_CLEAR_SELECTED_ITEMS: 'billing_system_overview_selected_items',
  /**
   * Utilizado após o recalculo do comissionamento
   */
  COMISSION_DATA: 'reload_comission_data',
  /**
   * Recarregar após alterar as regras
   */
  COMISSION_RULES: 'reload_comission_rules',
  /**
   * Recarregar após alterar os campos
   */
  COMISSION_FIELDS: 'reload_comission_fields',
  /**
   * Recarregar o status do fechamento
   */
  COMISSION_FECHAMENTO: 'reload_comission_fechamento',
  /**
   * Atualizar após mudança nas listas
   */
  COMISSION_LISTS: 'reload_comission_lists',
  /**
   * Atualizar após salvar grupos de pagamentos
   */
  COMISSION_PAYMENT_GROUPS: 'reload_commission_payment_group',
  /**
   * Atualizar os dados de pagamentos
   */
  COMISSION_PAYMENTS: 'reload_commission_payments',
  /**
   * reload_commission_clients
   */
  COMISSION_CLIENTS: 'reload_commission_clients',
  /**
   * reload_dashboard_update_info
   */
  DASHBOARD_UPDATE_INFO: 'reload_dashboard_update_info',
  /**
   * Recarregar Historico de valuation
   */
  HISTORIC_VALUATION: 'reload_historic_valuation',
  /**
   * Recarregar lista de avaliações
   */
  RELOAD_LIST_VALUATION: 'reload_list_valuation',
  BANK_DETAILS_IMPORTED: 'bank_details_imported',
  FP_PGBL: 'fp_pgbl',
  /**
   * Recarregar as transações de Financial Planning > Transações quando um filtro
   * de backend (período/datas) muda. Emitido pelo widget FpOrcamentosFilters;
   * a view (view-orcamentos) escuta e refaz o fetch pelo filtro do store.
   */
  FP_ORCAMENTOS: 'fp_orcamentos_data',
  CRM_RELATIONSHIP_SETTINGS: 'crm_relationship_settings',
  CRM_RELATIONSHIP_SETTINGS_NEW_ACTIVITY:
    'crm_relationship_settings_new_activity',
  CRM_FUNIL_SETTINGS: 'crm_funil_settings',
  CRM_OPORTUNIDADE_FUNIL_SETTINGS: 'crm_oportunidade_funil_settings',
  CRM_OPORTUNIDADE_KANBAN: 'crm_oportunidade_kanban',
  CRM_OPORTUNIDADE_DESFECHO_APLICADO: 'crm_oportunidade_desfecho_aplicado',
  CRM_FUNIL_SETTINGS_NEW_STEP: 'crm_funil_settings_new_step',
  CRM_FUNIL_SETTINGS_NEW_ACTIVITY: 'crm_funil_settings_new_activity',
  CRM_ORIGENS: 'crm_origens',
  FP_PGBL_NEW_SIMULATION: 'fp_pgbl_new_simulation',
  CRM_RELATIONSHIP_NEW_LEAD: 'crm_relationship_new_lead',
  CRM_RELATIONSHIP_NEW_TASK: 'crm_relationship_new_task',
  CRM_RELATIONSHIP_NEW_OPPORTUNITY: 'crm_relationship_new_opportunity',
  CRM_RELATIONSHIP_REMOVE_OPPORTUNITY: 'crm_relationship_remove_opportunity',
  CRM_RELATIONSHIP_DATA: 'crm_relationship_data',
  CRM_RELATIONSHIP_SINGLE_CLIENT: 'crm_relationship_single_client',
  // Patch de UM campo do cliente (payload { idClienteApp, field, value }) — a
  // aba de dados atribui só aquele campo, sem refetch (evita sobrescrever edições).
  CRM_CLIENT_FIELD_UPDATE: 'crm_client_field_update',
  CRM_LEAD_STATUS_CHANGED: 'crm:lead-status-changed',
  CRM_RELATIONSHIP_NEW_REGUA: 'crm_relationship_new_regua',
  CRM_RELATIONSHIP_TIMELINE_RELOAD: 'crm_relationship_timeline_reload',
  CRM_MONTHLY_ROUTINE_DATA: 'crm_monthly_routine_data',
  CRM_RELATIONSHIP_SEARCH_FILTER: 'crm_relationship_search_filter',
  CRM_LEADS_DATA: 'crm_leads_data',
  CRM_LIGACOES: 'crm_ligacoes_data',
  CRM_SUMMARY_LAYOUT: 'crm_summary_layout',
  CRM_EMPRESAS_LINK: 'crm_empresas_link',
  CRM_EMPRESAS: 'crm_empresas',
  CRM_GRUPO_FAMILIAR_LINK: 'crm_grupo_familiar_link',
  CRM_GRUPO_FAMILIAR: 'crm_grupo_familiar',
  CRM_AGENDA_DATA: 'crm_agenda_data',
  CRM_HISTORIC: 'crm_historic',
  CRM_HISTORIC_OPTIONS: 'crm_historic_options',
  CRM_CALENDAR: 'crm_calendar',
  CRM_CALENDAR_TIME_UPDATED: 'crm_calendar_time_updated',
  CRM_CALENDAR_DATE_UPDATED: 'crm_calendar_date_updated',
  CRM_LEAD_LOCAL_UPDATE: 'crm_lead_local_update',
  CONTROLADORIA_FECHAMENTOS: 'reload_controladoria_fechamentos',
  CONTROLADORIA_IMPORTACAO: 'reload_controladoria_importacao',
  CONTROLADORIA_CONFIG_DRE: 'reload_controladoria_config_dre',
  CONTROLADORIA_LISTAS: 'reload_controladoria_listas',
  CONTROLADORIA_ENGINE_STATUS: 'reload_controladoria_engine_status',
  CONTROLADORIA_CADASTROS: 'reload_controladoria_cadastros',
  CRM_CONVERSAS: 'crm_conversas',
  // Alias deprecated: novos consumers devem usar CRM_PROVIDERS_INTEGRATION.
  CRM_GOOGLE_INTEGRATION: 'reload_crm_providers_integration',
  CRM_PROVIDERS_INTEGRATION: 'reload_crm_providers_integration',
  /**
   * Módulo Central de IA (ai-framework, spec-002) — emitido após TODA mutação
   * bem-sucedida de instância (create/edit/pause/resume/migrate). Views re-disparam
   * fetchInstances (lesson "refresh after mutations", CLAUDE.md :1120).
   */
  AI_FRAMEWORK_INSTANCES: 'reload_ai_framework_instances',
  // Emitido pelo widget de filtros da Visão Geral do Financeiro (frequência +
  // período) ao aplicar; a view escuta para recarregar a DRE/DFC/saldo.
  FINANCE_OVERVIEW: 'reload_finance_overview',
  // Emitido pelo widget de filtros dos Demonstrativos (PJ + frequência +
  // período) ao aplicar; a view escuta para recarregar a DRE/DFC.
  FINANCE_DRE: 'reload_finance_dre',
  /**
   * Carteira de créditos (project-ia-payment) — emitido pelo MOTOR do chat
   * (`aawz-intelligence-v2/api/apiChat.js`) quando o stream de um turno FECHA,
   * porque é aí que o débito daquele turno já está lançado. Quem escuta é o
   * rodapé de saldo da lateral (`ai-framework/components/saldo-creditos-rodape`).
   *
   * ⚠️ O canal é o `end`? NÃO — e a diferença é a corrida: o backend debita
   * DEPOIS do `yield` do `end` (`usecase_ia_crm_chat.py`), então recarregar no
   * evento leria o saldo anterior. Ver o comentário do emissor.
   */
  CREDITOS_SALDO: 'reload_creditos_saldo',
}

/**
 * Sinais da carteira de créditos que atravessam módulos pelo `GlobalBus`.
 *
 * `CHAMAR_ATENCAO`: o turno foi RECUSADO por saldo esgotado (`status: 402` no
 * envelope — `gate_creditos.py`). Emissor: `apiChat._chamarAtencaoParaOsCreditos`.
 * Dois ouvintes, cada um com a sua reação: o rodapé de saldo da lateral
 * (`ai-framework/components/saldo-creditos-rodape`) pulsa por ~2,4s para o
 * consultor achar o botão "Meus créditos"; o composer do chat
 * (`aawz-intelligence-v2/mixins/aviso-de-creditos.js`) liga a faixa de bloqueio
 * sem esperar a releitura do saldo.
 */
export const CREDITOS = {
  CHAMAR_ATENCAO: 'creditos_chamar_atencao',
}

// Canais GlobalBus de coordenação que NÃO abrem modal — mesmo racional de
// RELOAD acima (não pertencem ao contrato de abertura MODAL.<NAME>). Movido
// de MODAL.CRM_TRANSCRICOES_MODO_EU (2026-09): mesmo desvio que
// RELOAD.TRANSCRIPT já corrigiu antes (era MODAL.TRANSCRIPT_RELOAD).
export const SEARCH_SIGNAL = {
  /**
   * Reusa o mesmo canal GlobalBus que runAction (busca global) já emite
   * incondicionalmente após a navegação, MESMO quando `$router.push` é
   * redundante (usuário clica a mesma ação de novo estando já na tela) —
   * reaplica o filtro "Somente eu"/"Modo eu" e reinicia o pulse de destaque
   * em view-crm-transcricoes-history.vue.
   */
  CRM_TRANSCRICOES_MODO_EU: 'crm_transcricoes_modo_eu',
}

export const RESTRICAO_DEFAULT = {
  pl: 0,
  perfil: 'Moderado',
  composicao_estrategica: {
    mm: 0.3,
    internacional: 0.05,
    rv: 0.1,
    fii: 0,
    rf_pos: 0.2,
    rf_inf: 0.1,
    rf_pre: 0.25,
    prev: 0,
    outros: 0,
    saldo_conta: 0,
  },
  ativos_fixos: [],
  fgc: { rf_pos: false, rf_inf: false, rf_pre: false },
  liquidez: {
    liq_0: 0,
    liq_3: 0,
    liq_15: 0,
    liq_30: 0,
    liq_180: 0,
    liq_360: 0,
    liq_720: 0,
    liq_1080: 0,
  },
  min_roa: 0,
  min_risco: 0,
  min_retorno: 0,
  janela_tempo: null,
  qtd_min: null,
  qtd_max: null,
  tipo_ativos: 'all',
  so_fundos: false,
}

export const RUNNING = {
  COTIZACAO: 'running_cotizacao',
  ATUALIZAR_BANCOS: 'atualizar_bancos',
  ATUALIZAR_BANCO: 'atualizar_banco',
}

export const STOP = {
  COTIZACAO: 'stop_cotizacao',
}

export const ACTIONS = {
  ADD_OBSERVATION: 'ips_add_observation',
  CLOSE_RESUME: 'close_modal_resume',
}

export const Meses = [
  'Jan',
  'Fev',
  'Mar',
  'Abr',
  'Mai',
  'Jun',
  'Jul',
  'Ago',
  'Set',
  'Out',
  'Nov',
  'Dez',
]

export const RATINGS = [
  'AAA',
  'AA+',
  'AA',
  'AA-',
  'A+',
  'A',
  'A-',
  'BBB+',
  'BBB',
  'BBB-',
  'BB+',
  'BB',
  'BB-',
  'B+',
  'B',
  'B-',
  'CCC',
  'CC',
  'C',
  'DDD',
  'DD',
  'D',
]

export const TIPOS_EMAILS = {
  PROPOSTA_PROSPECT: 'Proposta Prospect',
  PROPOSTA_CLIENTES: 'Proposta Clientes',
  PROPOSTA_SERVICOS: 'Proposta Serviços',
}

export const TIPOS_RF = [
  'CDB',
  'CRA',
  'CRI',
  'DEB',
  'LC',
  'LCA',
  'LCI',
  'LF',
  'LFSN',
  'LFT',
  'LTN',
  'NTN-B',
  'NTN-F',
]

export const TIPOS_RV = [
  'Ação',
  'Ações',
  'FII',
  'Fii',
  'Fundos Imobiliários',
  'Fundo Imobiliário',
  ASSETS_TYPES.ACOES_OFFSHORE,
  ASSETS_TYPES.BONDS,
  'Câmbio',
  ASSETS_TYPES.FUNDOS_OFFSHORE,
  ASSETS_TYPES.CRIPTO,
]

export const FORMAT_ORIGEM = {
  automatico: 'Contas Automáticas',
  automatica: 'Contas Automáticas',
  manual: 'Manual',
  profissional: 'Profissional',
}

// Eventos do dominio Tarefas emitidos no GlobalBus. O bus e infraestrutura
// neutra: permite o CRM reagir a criacao de tarefa sem o modulo Tarefas
// depender do CRM.
export const TAREFA = {
  CREATED: 'tarefa_created',
}

export const MODAL_EXPORT = {
  /**
   * modal_export_access_clients
   */
  ACCESS_CLIENTS: 'modal_export_access_clients',
  /**
   * modal_exportar_extrato_clientes
   */
  EXTRATO_CLIENTES: 'modal_exportar_extrato_clientes',
}

export const MODAL_IMPORT = {
  /**
   * modal_import_access_clients
   */
  ACCESS_CLIENTS: 'modal_import_access_clients',
  /**
   * modal_import_base_ativos
   */
  BASE_ASSETS: 'modal_import_base_ativos',
  /**
   * modal_import_manual_quotas_assets
   */
  MANUAL_QUOTAS: 'modal_import_manual_quotas_assets',
  /**
   * modal_importar_extrato_clientes
   */
  EXTRATO_CLIENTES: 'modal_importar_extrato_clientes',
}

export const BLACK_LIST_CALCULO_RENTABILIDADE = [
  'poupança',
  'outros',
  'proventos',
]

export const BLACK_LIST_DADOS_FALTANTE = [
  'poupança',
  'outros',
  'proventos',
  'saldo em conta',
]

export const TIPOS_PU_RESGATE_TOTAL = [
  'FII',
  'Fundos Imobiliários',
  'Fundo Imobiliário',
  'Ação',
  'Ações',
  'Renda Fixa',
]

export const TYPE_IPS_ANSWERS = [
  'text',
  'money',
  'percent',
  'liquidez',
  'perfil',
  'radio',
  'checkbox',
]

export const DIC_CLASSES_SIMULADOR = {
  'Renda Variável': 'rv',
  'Fundo Imobiliário': 'fii',
  Internacional: 'internacional',
  Multimercado: 'mm',
  'RF Pós-Fixado': 'rf_pos',
  'RF Inflação': 'rf_inf',
  'RF Pré-Fixado': 'rf_pre',
  'Fundo de Previdência': 'prev',
  // COE: 'coe',
  Alternativos: 'outros',
  // Outros: 'outros',
  'Saldo em Conta': 'saldo_conta',
}

export const DIC_RESTR_SIMULADOR = {
  rv: 'min_rv',
  fii: 'min_fii',
  internacional: 'min_int',
  mm: 'min_mm',
  rf_pos: 'min_rf_pos',
  rf_inf: 'min_rf_inflacao',
  rf_pre: 'min_rf_pre',
  prev: 'min_previdencia',
  coe: 'min_coe',
  outros: 'min_outros',
}

export const COMPOSICAO_PARA_CLASSE = {
  min_rv: 'Renda Variável',
  min_fii: 'Fundo Imobiliário',
  min_int: 'Internacional',
  min_mm: 'Multimercado',
  min_rf_pos: 'RF Pós-Fixado',
  min_rf_inflacao: 'RF Inflação',
  min_rf_pre: 'RF Pré-Fixado',
  min_previdencia: 'Fundo de Previdência',
  min_outros: 'Alternativos',
  saldo_conta: 'Saldo em Conta',
}

export const CLASSE_PARA_COMPOSICAO = {
  'Renda Variável': 'min_rv',
  'Fundo Imobiliário': 'min_fii',
  Internacional: 'min_int',
  Multimercado: 'min_mm',
  'RF Pré-Fixado': 'min_rf_pre',
  'RF Inflação': 'min_rf_inflacao',
  'RF Pós-Fixado': 'min_rf_pos',
  Alternativos: 'min_outros',
  'Fundo de Previdência': 'min_previdencia',
}

export const ESCALA_RISCO_CLASSES = {
  min_rv: {
    color: '#F44336',
    nome: 'Renda Variável',
  },
  min_fii: {
    color: '#FF9800',
    nome: 'Fundo Imobiliário',
  },
  min_int: {
    color: '#FFC107',
    nome: 'Internacional',
  },
  min_mm: {
    color: '#FFEE58',
    nome: 'Multimercado',
  },
  min_rf_pre: {
    color: '#CDDC39',
    nome: 'RF Pré-Fixado',
  },
  min_rf_inflacao: {
    color: '#8BC34A',
    nome: 'RF Inflação',
  },
  min_rf_pos: {
    color: '#4CAF50',
    nome: 'RF Pós-Fixado',
  },
  min_outros: {
    color: '#009688',
    nome: 'Alternativos',
  },
  min_previdencia: {
    color: '#03A9F4',
    nome: 'Fundo de Previdência',
  },
}

export const DIC_CLASSES_REVERSE_SIMULADOR = {
  rv: 'Renda Variável',
  fii: 'Fundo Imobiliário',
  internacional: 'Internacional',
  mm: 'Multimercado',
  rf_pos: 'RF Pós-Fixado',
  rf_inf: 'RF Inflação',
  rf_pre: 'RF Pré-Fixado',
  prev: 'Fundo de Previdência',
  // coe: 'COE',
  outros: 'Alternativos',
  saldo_conta: 'Saldo em Conta',
}

export const COMPR_ESTR_SIMULADOR_WITH_COLORS = {
  Multimercado: {
    name: 'Multimercado',
    color: '#374459',
    percent: 30,
  },
  Internacional: {
    name: 'Internacional',
    color: '#2e86ab',
    percent: 5,
  },
  'Renda Variável': {
    name: 'Renda Variável',
    color: '#2fb89f',
    percent: 10,
  },
  'Fundo Imobiliário': {
    name: 'Fundo Imobiliário',
    color: '#00796B',
    percent: 0,
  },
  'RF Pós-Fixado': {
    name: 'RF Pós-Fixado',
    color: '#645e9d',
    percent: 20,
  },
  'RF Inflação': {
    name: 'RF Inflação',
    color: '#e75735',
    percent: 10,
  },
  'RF Pré-Fixado': {
    name: 'RF Pré-Fixado',
    color: '#f29741',
    percent: 25,
  },
  'Fundo de Previdência': {
    name: 'Fundo de Previdência',
    color: '#6E1100',
    percent: 0,
  },
  Alternativos: {
    name: 'Alternativos',
    color: '#6c757d',
    percent: 0,
  },
  'Saldo em Conta': {
    name: 'Saldo em Conta',
    color: '#CFD8DC',
    percent: 0,
  },
}

export const TIPOS_CONFIG_ATIVOS = [
  {
    tipo: 'Ação',
    headers: [],
  },
  {
    tipo: 'FII',
    headers: [],
  },
  {
    tipo: 'Fundos',
    headers: [
      {
        text: 'CNPJ',
        value: 'referencia',
        width: 160,
      },
    ],
  },
  {
    tipo: 'Operações Estruturadas',
    headers: [],
  },
  {
    tipo: 'Personalizado',
    headers: [],
  },
  {
    tipo: 'RF',
    headers: [
      {
        text: 'Vencimento',
        value: 'vencimento',
        width: 100,
      },
      {
        text: 'Taxa',
        value: 'taxa',
        width: 120,
      },
    ],
  },
  {
    tipo: 'Bonds',
    headers: [],
  },
]

export const CLASSES_RF = ['RF Pós-Fixado', 'RF Inflação', 'RF Pré-Fixado']

/**
 * Lista de benchmarks usados para os cálculos.
 * Estes são os disponíveis para comparar rentabilidade.
 */
export const BENCHMARKS = [
  'CDI',
  'IPC-A',
  'IMA-B',
  'IBOVESPA',
  'IFIX',
  'IRF-M',
  'DÓLAR',
  'S&P 500',
  'CPI',
]

export const OPCOES_FILTRO_DATA = {
  SEMANA: 'Semana',
  MES: 'Mês',
  SEMESTRE: '6 Meses',
  YTD: 'Ano',
  ANO: '12 Meses',
  INICIO: 'Início',
  ESPECIFICA: 'Específica',
}

export const INDEXADORES = [
  'Taxa CDI',
  'CDI + Taxa',
  'CDI - Taxa',
  'IPC-A + Taxa',
  'IGP-M + Taxa',
  'SELIC + Taxa',
  'SELIC - Taxa',
  'Taxa',
]

export const TIPOS_RENDA_VARIAVEL = [
  'FII',
  'Ação',
  'Ações',
  'Fundos Imobiliários',
]

export const CLASSES_SIMULADOR = [
  'Alternativos',
  'Fundo Imobiliário',
  'Fundo de Previdência',
  'Internacional',
  'Multimercado',
  'RF Inflação',
  'RF Pré-Fixado',
  'RF Pós-Fixado',
  'Renda Variável',
  'Saldo em Conta',
]

export const tipos = {
  'fundos de investimento': 'Fundos de Investimentos',
  'Fundos de Investimento': 'Fundos de Investimentos',
  'Fundos de Investimentos': 'Fundos de Investimentos',
  FUNDOS: 'Fundos de Investimentos',
  FII: 'FII',
  Poupança: 'Operações Estruturadas',
  Ação: 'Ação',
  Ações: 'Ação',
  'Renda Fixa': 'Renda Fixa',
  'Fundos Imobiliários': 'FII',
  Outros: 'Operações Estruturadas',
  'Tesouro Direto': 'Tesouro Direto',
  'fundos de previdência': 'Fundos de Previdência',
  'Fundos de Previdência': 'Fundos de Previdência',
  Personalizado: 'Personalizado',
}

export const ROLES = {
  1: 'Gestor',
  3: 'Assessor',
  4: 'Back-office',
}

export const LINK_TUTORIALS = {
  'simulador.analise': {
    url: 'https://aawz-public.s3.us-east-2.amazonaws.com/tour-sistemav2/analise-carteira-simulada.mp4',
    title: 'ANÁLISE DA SIMULAÇÃO',
    description: '',
  },
  'simulador.comparativo': {
    url: 'https://aawz-public.s3.us-east-2.amazonaws.com/tour-sistemav2/analise-carteira-simulada.mp4',
    title: 'ANÁLISE DA SIMULAÇÃO',
    description: '',
  },
  'simulador.avancado': {
    url: 'https://aawz-public.s3.us-east-2.amazonaws.com/tour-sistema/002+-+Simulador+Avancado.mp4',
    title: 'SIMULADOR AVANÇADO',
    description: '',
  },
  'simulador.manual': {
    url: 'https://aawz-public.s3.us-east-2.amazonaws.com/tour-sistemav2/portfolio-review-manual.mp4',
    title: 'SIMULADOR MANUAL',
    description: '',
  },
  'simulador.automatico': {
    url: 'https://aawz-public.s3.us-east-2.amazonaws.com/tour-sistema/001+-+Simulador+Automatico.mp4',
    title: 'SIMULADOR AUTOMÁTICO',
    description: '',
  },
}

export const IPS_TIPOS_RESPOSTAS = [
  {
    tipo: 'text',
    text: 'Texto simples',
  },
  {
    tipo: 'perfil',
    text: 'Perfil Estratégico',
  },
  {
    tipo: 'radio',
    text: 'Seleção Única (Opção 1)',
  },
  {
    tipo: 'select',
    text: 'Seleção Única (Opção 2)',
  },
  {
    tipo: 'number',
    text: 'Numérico',
  },
  {
    tipo: 'money',
    text: 'Monetário',
  },
  {
    tipo: 'percent',
    text: 'Percentual',
  },
  {
    tipo: 'liquidez',
    text: 'Prazos de Liquidez',
  },
  {
    tipo: 'checkbox',
    text: 'Seleção Múltipla',
  },
  {
    tipo: 'fixar_ativos',
    text: 'Lista de ativos',
  },
  {
    tipo: 'composicao',
    text: 'Composição Estratégica',
  },
]

export const IPS_OPCOES_RESPOSTAS = {
  // perfil: ['Agressivo', 'Moderado', 'Conservador'],
  select: [],
  radio: [],
  checkbox: [],
}

export const ANOS_HORIZONTE = [
  {
    text: '3 anos',
    value: 3,
  },
  {
    text: '4 anos',
    value: 4,
  },
  {
    text: '5 anos',
    value: 5,
  },
  {
    text: '10 anos',
    value: 10,
  },
]

export const TIPOS_ATIVOS_CONSOLIDADOR = [
  'Ação',
  'Fundos de Investimentos',
  // 'Fundos de Previdência',
  'FII',
  'Operações Estruturadas',
  'Renda Fixa',
  'Tesouro Direto',
  'Personalizado',
  ASSETS_TYPES.CASHBACK,
]

export const TIPOS_COM_CUPOM = ['Renda Fixa', 'Tesouro Direto']

export const TIPOS_PLANO_CARREIRA = [
  'Comercial',
  'Produto',
  'Back-Office',
  'Suporte',
  'Mesa Proprietária',
  'Mesa Digital',
  'Executivo',
  'Operacional',
]

export const TIPOS_COM_AMORTIZACAO = ['Renda Fixa']

export const CAMPOS_ATIVOS_CONFIGURACOES = [
  'gestora',
  'isento',
  'liquidez',
  'mov_min',
  'nome_ativo',
  'pu',
  'qualificado',
  'quantidade_disponivel',
  'quantidade_minima',
  'ranking',
  'rating',
  'referencia',
  'roa',
  'saldo_permanencia',
  'subclasse',
  'subtipo1',
  'taxa',
  'tipo',
  'utilizar',
  'vencimento',
  'classe',
  'classe_anbima',
  'fixar',
  'aberto',
  'aplicacao_min',
  'emissor',
  'carencia',
  'empresa',
  'agencia',
  'moeda',
  'tags',
  'comentario',
  'recomendacao',
  'setor',
  'fundo_cnpj',
  'fundo_subclasse',
]

export const WITHOUT_PORTFOLIO = 'Sem Portfólio'

export const MAP_NAMES_SHEETS_SETTINGS = {
  posicao_fundos: 'FUNDOS',
  movimentacoes: 'MOVIMENTAÇÕES',
  client_data: 'BASE',
  posicao_rf: 'RENDA FIXA',
  retroativo: 'RETROATIVO',
  posicao_rv: 'RENDA VARIÁVEL',
}

/**
 * Texto antes: {{ TEXT_BEFORE_HELP_SHEETS_SETTTINGS }}
 */
export const MAP_HELP_SHEETS_SETTINGS = {
  posicao_fundos:
    'Acessar o sistema da corretora em: Operacionalização -> Relatórios -> Painéis -> Fundos -> Posições',
  movimentacoes:
    'Acessar o sistema da corretora em: Operacionalização -> Relatórios -> Gerencial -> Movimentação',
  client_data:
    'Criar o DE-PARA entre a "Conta" (na corretora) e o "E-mail" (no sistema) do cliente. ',
  posicao_rf:
    'Acessar o sistema da corretora em: Operacionalização -> Relatórios -> Painéis -> Renda Fixa -> Posições',
  retroativo: '',
  posicao_rv:
    'Acessar o sistema da corretora em: Operacionalização -> Relatórios -> Painéis -> Renda Variável -> Posições',
  'SALDO EM CONTA':
    'Acessar o sistema da corretora em: Operacionalização > Relatórios > Gerencial > Financeiro > Saldo em conta corrente d-0',
  'FUNDOS DE PREVIDÊNCIA':
    'Acessar o sistema da corretora em: Operacionalização -> Relatórios -> Painéis -> PREVIDÊNCIA -> PREVIDÊNCIA ',
}

export const TEXT_BEFORE_HELP_SHEETS_SETTTINGS =
  'Para obter a planilha, você pode:'

export const ATIVO_PERSONALIZADO_GLOBAL = 'Global'
export const ATIVO_PERSONALIZADO_ESPECIFICO = 'Específico'

export const nomeRentabilidades = {
  rentabilidade: 'Rentabilidade',
  rentabilidade_relativo: '% CDI',
  ipca: 'IPC-A',
  imab: 'IMA-B',
  ibov: 'IBOVESPA',
  selic: 'SELIC',
  ifix: 'IFIX',
  irfm: 'IRF-M',
  dolar: 'DÓLAR',
  sp500: 'S&P 500',
}

export const REGIOES = [
  'SP Capital',
  'SP Interior',
  'Rio de Janeiro',
  'Sudeste',
  'Sul',
  'Nordeste',
  'Centro-Oeste',
  'Norte',
]

export const nomeRentabilidadesRevert = {
  Rentabilidade: 'rentabilidade',
  CDI: 'rentabilidade_relativo',
  'IPC-A': 'ipca',
  'IMA-B': 'imab',
  IBOVESPA: 'ibov',
  SELIC: 'selic',
  IFIX: 'ifix',
  'IRF-M': 'irfm',
  DÓLAR: 'dolar',
  'S&P 500': 'sp500',
}

export const BI_TIPOS_PLANILHAS = {
  PLN01: {
    codigo: 'PLN01',
    title: 'Planilha Cadastro Equipe',
    attrURL: 'profissionais', // URL.bi.planilhas.profissionais
    referencia: 'PLN01-Partnership-Equipe',
  },
  PLN02: {
    codigo: 'PLN02',
    title: 'Planilha Clientes + Assessores',
    attrURL: 'clientes',
    referencia: 'PLN02-Partnership-Clientes',
  },
}

/**
 * Mapeamento das Feature Flags disponíveis na plataforma
 * @type Object
 */
export const FEATURES = {
  CHAT_IA: 'AAWZ Intelligence',
  IA_CRM_CHAT: 'IA CRM Chat',
  // Lista de Espera do profissional (questionário de onboarding).
  //
  // ★ O literal TEM de ser byte-idêntico a `FuncionalidadesNames.ListaEspera`
  // no backend (`aawz_base/api/db_dir/escritorio/api_office_funcionalidades.py`)
  // — é a chave dentro do `$access`, não um rótulo de exibição. Divergir aqui
  // não dá erro: a comparação simplesmente não casa e a tela some em silêncio.
  //
  // A flag é GENÉRICA (decisão do owner, 21/09): ela diz QUE existe fila de
  // espera para o profissional, não QUAL — quem diz é o backend, em
  // `profissional_lista_espera.contexto` ('hub-gestao' = fila do Hub de Gestão).
  LISTA_ESPERA: 'Lista de Espera',
  // IA do Fee Fixo — ANINHADA dentro de `Fee Fixo`, não substituta. Cobre o
  // ensaio (role play) e os filtros por linguagem natural da tela de clientes.
  //
  // ★ A string TEM de ser idêntica ao valor de `FuncionalidadesNames.IAFeeFixo`
  // no backend: é ela a chave dentro do `$access`, não um rótulo de exibição.
  // Divergir aqui não dá erro — o acesso simplesmente nunca resolve, e a
  // funcionalidade fica invisível para todo mundo, em silêncio.
  IA_FEE_FIXO: 'IA - Fee Fixo',
  // Modo Agente do chat agêntico estilo Claude Code (spec-002). ★ String
  // idêntica a `FuncionalidadesNames.IaAgente` no backend
  // (`api_office_funcionalidades.py`) — é a chave dentro do `$access`, não um
  // rótulo de exibição.
  //
  // ⚠️ [18/09/2026] NÃO gateia mais nada no front: o Modo Agente é obrigatório
  // (`view-chat-modo-agente.mixin.js::modoAgenteLigado` é
  // `!modoAgenteRecusadoPeloBackend`, e a queda para o Modo Chat vem do 403
  // por funcionalidade do backend). A constante fica porque a flag continua
  // chegando no `$access`, e os testes-controle de `view-chat-modo-agente.
  // unit.js` a usam para provar que nenhuma combinação de flags desliga o modo.
  IA_AGENTE: 'IA - Agente',
  // Análise agêntica do chat (spec-003): anexo no composer, execução de código
  // e artefato (planilha/documento/gráfico). Vale nos DOIS modos — diferente de
  // `IA_AGENTE`, que só seleciona o RUNTIME do turno (E-7/E-28).
  //
  // ★ SEM ACENTO, de propósito. A chave dentro do `$access` é a string CRUA da
  // tabela `escritorio_funcionalidades`, e o backend lê exatamente
  // `'IA - Analise Agentica'` (`aawz_intelligence_v2/core/tools_access.py:55`).
  // A spec-003 escreve o rótulo acentuado; divergir aqui não dá erro — o acesso
  // simplesmente nunca resolve e a funcionalidade fica invisível para todo
  // mundo, em silêncio (o mesmo aviso de `IA_FEE_FIXO` logo acima).
  //
  // ⚠️ Medido em 19/09/2026: a funcionalidade ainda NÃO é cadastrável — não está
  // em `FuncionalidadesNames` nem no CHECK de `escritorio_funcionalidades`, que
  // só aceita `'IA - Agente'`. Até a migration que recria o CHECK, quem liga o
  // anexo em desenvolvimento é o override de `utils/anexos-liberados.js`.
  IA_ANALISE_AGENTICA: 'IA - Analise Agentica',
  // ★ [spec-008 T046] NÃO existe chave da voz em tempo real aqui, e a
  // ausência é DECISÃO (D-O-4, 17/09/2026): o transporte em tempo real é o
  // PADRÃO do Modo de Voz, não um opt-in por escritório. A `IA_VOZ_TEMPO_REAL`
  // que vivia nesta linha era lida por `utils/contexto-de-voz-tempo-real.js` e
  // saiu inteira — o próprio banco deu o argumento: a funcionalidade nem
  // existe no `CHECK constraint` de `escritorio_funcionalidades`, então ligá-la
  // exigiria migration. Não era gate, era obstáculo. O que continua de pé é
  // TRAVA, nunca rollout: queda para o v1, Ditar sempre por turnos, guarda das
  // quatro portas, catálogo somente-leitura e teto de duração.
  // IA do Comissionamento — o Especialista em Comissionamento, servido pela rota
  // dedicada `/comissoes/chat`. ANINHADA dentro de `Comissões`: quem não tem o
  // módulo não tem o agente.
  //
  // ★ Mesma armadilha da flag acima: a string TEM de ser idêntica ao valor de
  // `FuncionalidadesNames.IaComissoes` no backend, que é a chave dentro do
  // `$access` — não um rótulo de exibição. Divergir não dá erro: o acesso nunca
  // resolve, a aba some para todo mundo e a tela fica invisível em silêncio.
  IA_COMISSOES: 'IA - Comissões',
  // Canal WhatsApp da IA (flag de escritório, opt-in) — item "Conectar
  // WhatsApp" no menu do avatar; o backend exige a mesma flag.
  IA_WHATSAPP: 'IA - WhatsApp',
  // Botão "Resumir não lidas com a IA" no Omnichannel (flag de escritório,
  // opt-in, separada do canal); o backend exige a mesma flag na rota do prompt.
  IA_WHATSAPP_RESUMO: 'IA - WhatsApp Resumo',
  REPOSITORY_FILES: 'Repositório de Arquivos',
  CONSOLIDATOR_OVERVIEW: 'Consolidador Visão Geral',
  IA_SDR: 'Comercial',
  IA_SDR_SIMULATION: 'Simulação Mesa Digital',
  SIMULADOR: 'portfolio_review',
  WORKSPACE: 'workspace',
  BTG_WORKSHEETS: 'btg_worksheets',
  XP_WORKSHEETS: 'xp_worksheets',
  SETTINGS: 'settings', // Legacy flag (sempre habilitada)
  PARTNERSHIP: 'partnership',
  SERVICES: 'services',
  PRODUCTS: 'products',
  DASHBOARD: 'dashboard',
  NEWS: 'news',
  COMMUNICATIONS_CLIENT: 'communications-client',
  BPO_FINANCE: 'bpo-finance',
  DOCS: 'contracts',
  PORTFOLIO_FEES: 'portfolio-fee', // Legacy flag (sempre habilitada)
  MIX_PRODUTOS: 'Mix-Produto',
  PARTNERSHIP_DATA_ROOM: 'data-room',
  PARTNERSHIP_RANKING_CAPTACAO: 'Partnership Ranking Captacao',
  PARTNERSHIP_UPLOAD: 'Partnership - Upload documentos',
  DAILY_TASKS: 'daily-task',
  BI_EMBED: 'bi-embeded',
  PROFESSIONALS: 'manage-professionals',
  BONIFICATION: 'bonus-goals',
  GOALS: 'goals',
  BI_CUSTOMIZED: 'bi-customized',
  TREASURY: 'treasury',
  ASSET_LOCATION: 'asset-allocation',
  // Libera Configurações > Asset Allocation > Ativos para o profissional NÃO-gestor
  // (consultor), com as mesmas ações do gestor. Default OFF (opt-in por escritório):
  // sem a flag, a tela e as rotas seguem gestor-only — o comportamento de hoje.
  // ★ O valor precisa ser IDÊNTICO a `FuncionalidadesNames.BaseAtivosConsultor` no
  // aawz-web-backend (aawz_base/api/db_dir/escritorio/api_office_funcionalidades.py).
  // String divergente não dá erro: a flag nunca casa e a tela some em silêncio.
  BASE_ATIVOS_CONSULTOR: 'Base de Ativos - Consultor',
  // Curadoria das sugestões de IA no Consolidador: selo no nome do ativo, linha na
  // legenda, Carteira atual, Extrato e a aba "Sugestões da IA" — seis pontos de gate,
  // inventariados em modules/consolidator/CLAUDE.md. É a ÚNICA condição, NÃO aninhada em
  // CHAT_IA: curar não consome IA. Default OFF (opt-in por escritório).
  // ★ O valor precisa ser IDÊNTICO a `FuncionalidadesNames.ConsolidadorSugestoesIa` no
  // aawz_base (api/db_dir/escritorio/api_office_funcionalidades.py) e à `key` do Interno
  // (src/modules/settings/constants/Text.js). String divergente não dá erro: a flag nunca
  // casa e a tela some em silêncio.
  CONSOLIDADOR_SUGESTOES_IA: 'Consolidador - Sugestões da IA',
  // Libera a LEITURA de todas as transcrições do CRM (reuniões e ligações) do
  // escritório para o profissional NÃO-gestor, junto dos dados de cliente
  // derivados (ficha, life events) e do dashboard de scores. NÃO concede
  // escrita — editar/excluir transcrição de terceiro continua negado mesmo com
  // a flag ligada. Default OFF (opt-in nominal): exige linha do escritório em
  // `escritorio_funcionalidades` E linha do profissional em
  // `escritorio_funcionalidade_profissional` com `possui_acesso=True`. Sem
  // efeito para gestor — ele já tem visão ampla por `session['gestor']`.
  // ★ O valor precisa ser IDÊNTICO a `FuncionalidadesNames.TranscricoesTodas` no
  // aawz-web-backend (aawz_base/api/db_dir/escritorio/api_office_funcionalidades.py).
  // String divergente não dá erro: a flag nunca casa e a tela some em silêncio.
  TRANSCRICOES_TODAS: 'CRM - Transcrições (Todas)',
  OPEN_FINANCE_PJ: 'open-finance-pj',
  MANAGE_REDEMPTION: 'manage-redemption',
  SUPPORT: 'support',
  CLIENTS: 'clients',
  BOLETADOR: 'boletador',
  OPPORTUNITIES: 'Oportunidades',
  CRM: 'CRM',
  // Aba Ligações do CRM (API4Com) — opt-in por escritório (sem registro = oculta)
  CRM_LIGACOES: 'CRM Ligações',
  // Proposta R2 — a tela que monta o payload do deck comercial 16:9 (a proposta
  // da segunda reunião). Opt-in por escritório: sem registro em
  // `escritorio_funcionalidades`, a aba não existe para ninguém.
  //
  // ★ A string TEM de ser idêntica a `FuncionalidadesNames.CrmPropostaR2` no
  // aawz-web-backend (aawz_base/api/db_dir/escritorio/api_office_funcionalidades.py)
  // — é ela a chave dentro do `$access`, não um rótulo. Divergir não dá erro:
  // a aba some em silêncio.
  CRM_PROPOSTA_R2: 'CRM Proposta R2',
  TASKS: 'Tarefas',
  TASK_V2: 'Gerenciador de tarefas',
  // Workflow Engine (automações) — opt-in por escritório. O value DEVE casar com o
  // nome da funcionalidade em escritorio_funcionalidades; sem registro = oculto.
  WORKFLOW_ENGINE: 'workflow-engine',
  // Grupos Familiares (CRM) — opt-in por escritório. O value DEVE casar com o
  // nome da funcionalidade em escritorio_funcionalidades; sem registro = oculto.
  FAMILY_GROUP: 'family-group',
  CAPTABLE: 'captable',
  FATURAMENTO: 'faturamento',
  COMISSOES: 'Comissoes',
  COMISSOES_OVERVIEW: 'Comissoes Visao Geral',
  COMISSOES_APURACOES_RESUMO: 'Comissoes Apuracoes Resumo',
  COMISSOES_INTERNAL: 'Comissoes',
  COMISSOES_RATEIO_PROFISSIONAL: 'Comissoes Rateio Profissional',
  COMISSOES_MANAGER: 'Gestor das Comissões', // Se tem acesso de gestor no módulo de comissões
  COMISSOES_PROFESSIONAL_PAYMENT_DETAIL:
    'Comissoes Detalhe de Pagamento Profissional',
  COMISSOES_BASE_CLIENTES: 'Comissões Base de Clientes',
  COMISSOES_RELATORIOS_AVANCADOS: 'Comissões Relatórios Avançados',
  COMISSOES_REGRA_COM_NOME: 'Comissões Regras com Nome Profissional',
  COMISSOES_FECHAMENTO_PARCIAL: 'Comissões Disponibilização Parcial',
  COMISSOES_HIDE_OPTIONS_SEARCH: 'Comissões Esconder Tags',
  COMISSOES_HIDE_COMMISSION_GENERATED: 'Comissões Esconder Comissão Gerada',
  // Zera "Comissão Gerada" para itens com tipo diferente de "Comissão"
  // (ajustes, comissão mínima, gatilhos). Quando desligada, a coluna soma todos os tipos.
  COMISSOES_HIDE_NON_COMMISSION_GENERATED:
    'Comissões Esconder Comissão Gerada Não-Comissão',
  TESOURARIA_FORMULARIO_REEMBOLSO: 'Formulário de Pagamento',
  TESOURARIA_REEMBOLSO_OUTRO_PROFISSIONAL: 'Reembolso Outro Profissional', // Permite solicitar um pagamento de reembolso para outro profissional
  BROKKR: 'brokkr',
  HOME: 'home', // Legacy flag (sempre habilitada)
  BI_ONBOARDING: 'bi-onboarding',
  SETTINGS_V2: 'settings-v2',
  BI_V2: 'BI v2',
  // navegacao_2026 — nova navegação de dois contextos (gestão ↔ cliente)
  NAVEGACAO_2026: 'navegacao_2026',
  // home_ia — a IA Driven em tela cheia (`/ia`): a raiz da plataforma abre o
  // chat. Literal = `FuncionalidadesNames.HomeIa` no `aawz_base`; liberada no
  // CHECK das duas tabelas de funcionalidade pela migration v632.
  HOME_IA: 'home_ia',
  DISCLAIMERS_CAPTABLE: 'disclaimers_captable',
  SAAS: 'SaaS',
  ESTRATEGIA: 'Estratégia',
  COMITE_RESULTADOS: 'Comite Resultados',
  CAMPANHAS_DATA_ROOM: 'campanhas-data-room',
  P_L_PROFISSIONAL: 'P&L - Profissional',
  P_L_AREA_DE_RECEITA: 'P&L - Área de Receita',
  P_L_EQUIPE: 'P&L - Equipe',
  P_L_FILIAL: 'P&L - Filial',
  P_L_PJ: 'P&L - PJ',
  CORRETORA: 'BI Corretora',
  ORCADO_REALIZADO: 'Orçado vs Realizado',
  RH: 'Gestão de desempenho', // Acesso ao modulo
  RH_PARTICIPACAO: 'Gestão de desempenho - Participação', // Defini se vai aparecer na lista dos que participam das avaliações
  RH_GESTOR: 'Gestão de desempenho - Gestor', // Acesso de gestor na parte de gestão de desempenho mas sem acesso de gestor a outras areas
  RH_CONSULTOR: 'Gestão de desempenho - Consultor', // Acesso de gestor somente com visualização sem acesso a parte de avaliações
  DETAILS_DRE: 'Detalhamento DRE',
  COMISSOES_BASE_DE_DADOS: 'Comissões Base de Dados',
  EVENTOS: 'CRM - Eventos',
  EVENTOS_GESTOR: 'CRM - Eventos (Gestor)',
  KIT_SOCIETARIO: 'Kit Societário',
  HOME_DYNAMIC_VERSION: 'Home Dynamic', // Legacy flag (sempre habilitada)
  NAVIGATION_ONLY_COLOR: 'Navegação cor única',
  BACK_OFFICE: 'Back Office',
  FINANCIAL_PLANNING: 'Financial Planning - Simulação PGBL',
  FINANCIAL_PLANNING_SIMULATOR: 'Financial Planning',
  // Libera as 3 telas do Financial Planning (Visão Geral, Transações,
  // Objetivos) para o CLIENTE final logado. Não gateia nada do profissional e
  // NÃO é condicionada a FINANCIAL_PLANNING_SIMULATOR no ramo do cliente.
  // O literal é casado por igualdade de string com `escritorio_funcionalidades`
  // no backend: divergir aqui não levanta erro em lugar nenhum — a tela
  // simplesmente não aparece.
  FINANCIAL_PLANNING_CLIENTE: 'Financial Planning Cliente',
  BACK_OFFICE_DATA_ROOM: 'Back office - Data room',
  COMISSOES_CATEGORIA_DRE_INTERNO: 'Comissões Categoria DRE Interno',
  COMISSOES_MOSTRAR_CATEGORIA_DRE: 'Comissoes Mostrar Categoria DRE',
  MODELOS: 'Partnership - Modelos',
  COMISSOES_REMOVER_APROVACAO: 'Comissões Remover Aprovacao',
  CONSOLIDADOR_CARTEIRA_ANALISE_RISCO:
    'Consolidador - Carteiras - Análise de risco', // Legacy flag (sempre habilitada)
  COBRANCAS_CVM: 'Cobranças CVM',
  WS: 'Wealth Service',
  // WS_BACKOFFICE saiu em 28/08/2026. A área de Backoffice do WS (onboarding,
  // migrações, custódia, preço médio, cobranças, profissionais) nunca foi uma
  // feature CONTRATÁVEL: quem a usa é o time que OPERA o Wealth Service, e a
  // fila que ela abre é cross-tenant. Como flag, bastaria habilitar a linha em
  // `escritorio_funcionalidades` para um parceiro ver o trabalho de todos os
  // outros escritórios. O gate virou por ESCRITÓRIO — ver `BACKOFFICE_META` em
  // `modules/ws/routes.js` e `ehEscritorioInternoAawz`.
  RELATORIO_V2: 'Relatório v2',
  COMISSOES_GATILHOS: 'Comissoes Gatilhos',
  COMISSOES_ROA: 'Comissoes ROA', // Aba ROA do módulo de Comissões: custódia, receita e ROA por assessor
  COMPLIANCE: 'Compliance',
  OCULTAR_CROSS_SELL: 'Ocultar Cross-Sell', // Oculta superfícies de cross-sell/upsell (ModuleUpsellCard FP, prompts AAWZ Intelligence, sub-seções Compliance no CRM, etc.) para escritórios que pediram opt-out
  AAWZ_DRIVE: 'AAWZ Drive', // Módulo do Drive
  CONTROLADORIA_V2: 'Controladoria V2', // Módulo Controladoria V2 (gating geral)
  CONTROLADORIA_V2_LIMITED_AAWZ: 'Controladoria V2 Acesso Limitado AAWZ', // Controladoria V2 acessível apenas para usuários internos AAWZ
  FEE_FIXO: 'Fee Fixo', // Módulo Gestão Fee Fixo (simulação migração comissionado → fee fixo)
  AVENUE_IMPORT: 'Importacao Avenue', // Importação de clientes via planilha Avenue
  ATENDIMENTO: 'Atendimento',
  BACK_OFFICE_SELF_SERVICE: 'Back Office - Operação Autônoma', // Permite profissionais do escritório operarem o back-office sem depender do time interno
  TRANSCRICOES: 'AAWZ Transcrições',
  PLATAFORMA_BPO_FINANCEIRO: 'Plataforma BPO Financeiro', // Gateia o módulo "Rotina Financeira" (embed `finia` da plataforma de BPO financeiro)
  SOLICITACOES: 'Solicitações', // Módulo Solicitações (aba Comunicação). Deve casar com FuncionalidadesNames.Solicitacoes no aawz_base
  REQUISICOES: 'Requisições', // Tela Requisições liberável para profissionais externos por escritório. Deve casar com FuncionalidadesNames.Requisicoes no aawz_base
  // Central de IA (AAWZ IA Framework) — projeto ai-framework-parceiros. Flag-mestra
  // do módulo (catálogo + instâncias). Deve casar com FuncionalidadesNames.AawzIaFramework
  // no aawz_base (spec-001).
  AI_FRAMEWORK: 'AAWZ IA Framework',
  // Opt-in por escritório para liberar o toggle "Permitir ações de escrita" nos
  // agentes ativados (NC-5, spec-002). Deve casar com
  // FuncionalidadesNames.AawzIaFrameworkWriteTools no aawz_base.
  AI_FRAMEWORK_WRITE_TOOLS: 'AAWZ IA Framework Write Tools',
  CENTRAL_CONFIG: 'Jornada de Configuração', // Jornada guiada de configuração. Só visível com a flag habilitada. Deve casar com FuncionalidadesNames no aawz_base
  // Jornada do cliente (NovoResumo): lista priorizada, barra de etapas no
  // perfil e página de resumo. String DEVE casar com FuncionalidadesNames no
  // aawz_base — divergir faz a tela sumir em silêncio.
  CLIENT_JOURNEY: 'Jornada do Cliente',
}

export const CANT_ACCESS_FUNCTION =
  'Você não tem acesso a esta funcionalidade, fale com um consultor para mais informações.'

export const BPO_ORIGEM_METRICA = {
  USER: 'USER',
}

export const ORIGENS = [
  {
    text: 'Importação de Permissões',
    value: 'Importação de Permissões',
  },
  {
    text: 'Importação de Clientes',
    value: 'Importação de Clientes',
  },
  {
    text: 'Importação BTG',
    value: 'Importação BTG',
  },
  {
    text: 'Importação Nubank',
    value: 'Importação Nubank',
  },
  {
    text: 'Registro Manual',
    value: 'Registro Manual',
  },
  {
    text: 'Via App (Orgânico)',
    value: 'Via App (Orgânico)',
  },
  {
    text: 'Via Web (Orgânico)',
    value: 'Via Web (Orgânico)',
  },
  {
    text: 'Link de Serviço',
    value: 'Link de Serviço',
  },
  {
    text: 'Plataforma Web',
    value: 'web',
  },
  {
    text: 'Aplicativo',
    value: 'app',
  },
]

export const LOCAL_STORAGES = {
  /**
   * local_storage_tutorials
   */
  COMISSOES_VISIBLE_VALUES_CHANGED: 'comissoes-visible-values-changed',
  CONTROLADORIA_PREFIX: 'ctrldr_',
}

export const TECH_CONTACT_NUMBER = '5548996382146'

export const MONTH_NAMES = [
  'Janeiro',
  'Fevereiro',
  'Março',
  'Abril',
  'Maio',
  'Junho',
  'Julho',
  'Agosto',
  'Setembro',
  'Outubro',
  'Novembro',
  'Dezembro',
]

/**
 * Grupos exibidos como chip nos resultados da busca global (command palette).
 * Espelham as seções do menu de navegação — ver navigation-routes.js.
 */
export const SEARCH_GROUPS = {
  ANALISES: 'Análises',
  GESTAO_OPERACIONAL: 'Gestão Operacional',
  GESTAO_ESCRITORIOS: 'Gestão de escritórios',
  GESTAO_PORTFOLIOS: 'Gestão de portfólios',
  GESTAO_PESSOAS: 'Gestão de pessoas',
  FERRAMENTAS: 'Ferramentas',
  OUTROS: 'Outros',
  CONFIGURACOES: 'Configurações',
}

export const simuladorRoutesGeral = () => [
  { name: 'simulador.selecionar', title: 'Visão geral' },
  { name: 'simulador.historico', title: 'Histórico' },
  { name: 'simulador.analise', title: 'Análise' },
  { name: 'simulador.comparativo', title: 'Comparativo' },
]

export const simuladorRoutesSimulacao = () => [
  { name: 'simulador.manual', title: 'Manual' },
  { name: 'simulador.automatico', title: 'Automático' },
  { name: 'simulador.guiado', title: 'Guiado' },
  { name: 'simulador.avancado', title: 'Avançado' },
]

export const simuladorRoutes = () => [
  ...simuladorRoutesGeral(),
  ...simuladorRoutesSimulacao(),
]
